(function () {
  var a,
    b,
    c,
    d,
    e,
    f,
    g = function (a, b) {
      return function () {
        return a.apply(b, arguments);
      };
    };
  (b = (function () {
    function a() {
      this.update = g(this.update, this);
    }
    return (
      (a.prototype.update = function (a) {
        var b, c, e;
        for (c in a) (e = a[c]), "items" !== c && (this[c] = e);
        return (this.items = (function () {
          var c, e, f, g;
          for (f = a.items, g = [], c = 0, e = f.length; e > c; c++) (b = f[c]), g.push(new d(b));
          return g;
        })());
      }),
      a
    );
  })()),
    (d = (function () {
      function a(a) {
        (this.propertyArray = g(this.propertyArray, this)),
          (this.update = g(this.update, this)),
          this.update(a);
      }
      return (
        (a.prototype.update = function (a) {
          var b, d;
          for (b in a) (d = a[b]), "properties" !== b && (this[b] = d);
          return (this.properties = c.Utils.extend({}, a.properties));
        }),
        (a.prototype.propertyArray = function () {
          var a, b, c, d;
          (c = this.properties), (d = []);
          for (a in c) (b = c[a]), d.push({ name: a, value: b });
          return d;
        }),
        a
      );
    })()),
    (c = {
      settings: {
        debug: !1,
        dataAPI: !0,
        requestBodyClass: null,
        rivetsModels: {},
        currency: null,
        moneyFormat: null,
        moneyWithCurrencyFormat: null,
        weightUnit: "g",
        weightPrecision: 0,
      },
      cart: new b(),
    }),
    (c.init = function (a, b) {
      return (
        null == b && (b = {}),
        c.configure(b),
        c.Utils.log("Initialising CartJS."),
        c.cart.update(a),
        c.settings.dataAPI &&
          (c.Utils.log('"dataAPI" setting is true, initialising Data API.'), c.Data.init()),
        c.settings.requestBodyClass &&
          (c.Utils.log('"requestBodyClass" set, adding event listeners.'),
          jQuery(document).on("cart.requestStarted", function () {
            return jQuery("body").addClass(c.settings.requestBodyClass);
          }),
          jQuery(document).on("cart.requestComplete", function () {
            return jQuery("body").removeClass(c.settings.requestBodyClass);
          })),
        c.Rivets.init(),
        jQuery(document).trigger("cart.ready", [c.cart])
      );
    }),
    (c.configure = function (a) {
      return null == a && (a = {}), c.Utils.extend(c.settings, a);
    }),
    null == window.console && ((window.console = {}), (window.console.log = function () {})),
    (c.Utils = {
      log: function () {
        return c.Utils.console(console.log, arguments);
      },
      error: function () {
        return c.Utils.console(console.error, arguments);
      },
      console: function (a, b) {
        return c.settings.debug && "undefined" != typeof console && null !== console
          ? ((b = Array.prototype.slice.call(b)), b.unshift("[CartJS]:"), a.apply(console, b))
          : void 0;
      },
      wrapKeys: function (a, b, c) {
        var d, e, f;
        null == b && (b = "properties"), (f = {});
        for (d in a) (e = a[d]), (f["" + b + "[" + d + "]"] = null != c ? c : e);
        return f;
      },
      unwrapKeys: function (a, b, c) {
        var d, e, f, g;
        null == b && (b = "properties"), (e = {});
        for (d in a)
          (g = a[d]),
            (f = d.replace("" + b + "[", "").replace("]", "")),
            (e[f] = null != c ? c : g);
        return e;
      },
      extend: function (a, b) {
        var c, d;
        for (c in b) (d = b[c]), (a[c] = d);
        return a;
      },
      clone: function (a) {
        var b, c;
        if (null == a || "object" != typeof a) return a;
        c = new a.constructor();
        for (b in a) c[b] = clone(a[b]);
        return c;
      },
      isArray:
        Array.isArray ||
        function (a) {
          return "[object Array]" === {}.toString.call(a);
        },
      ensureArray: function (a) {
        return c.Utils.isArray(a) ? a : null != a ? [a] : [];
      },
      formatMoney: function (a, b, d, e) {
        var f, g;
        return (
          null == e && (e = ""),
          e || (e = c.settings.currency),
          null != window.Currency &&
            e !== c.settings.currency &&
            ((a = Currency.convert(a, c.settings.currency, e)),
            null != (null != (f = window.Currency) ? f.moneyFormats : void 0) &&
              e in window.Currency.moneyFormats &&
              (b = window.Currency.moneyFormats[e][d])),
          null != (null != (g = window.Shopify) ? g.formatMoney : void 0)
            ? Shopify.formatMoney(a, b)
            : a
        );
      },
      getSizedImageUrl: function (a, b) {
        var c, d;
        return null !=
          (null != (c = window.Shopify) && null != (d = c.Image) ? d.getSizedImageUrl : void 0)
          ? a
            ? Shopify.Image.getSizedImageUrl(a, b)
            : Shopify.Image.getSizedImageUrl(
                "https://cdn.shopify.com/s/images/admin/no-image-.gif",
                b
              ).replace("-_", "-")
          : a
          ? a
          : "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
      },
    }),
    (f = []),
    (e = !1),
    (c.Queue = {
      add: function (a, b, d) {
        var g;
        return (
          null == d && (d = {}),
          (g = {
            url: a,
            data: b,
            type: d.type || "POST",
            dataType: d.dataType || "json",
            success: c.Utils.ensureArray(d.success),
            error: c.Utils.ensureArray(d.error),
            complete: c.Utils.ensureArray(d.complete),
          }),
          d.updateCart && g.success.push(c.cart.update),
          f.push(g),
          e
            ? void 0
            : (jQuery(document).trigger("cart.requestStarted", [c.cart]), c.Queue.process())
        );
      },
      process: function () {
        var a;
        return f.length
          ? ((e = !0), (a = f.shift()), (a.complete = c.Queue.process), jQuery.ajax(a))
          : ((e = !1), void jQuery(document).trigger("cart.requestComplete", [c.cart]));
      },
    }),
    (c.Core = {
      getCart: function (a) {
        return (
          null == a && (a = {}),
          (a.type = "GET"),
          (a.updateCart = !0),
          c.Queue.add("/cart.js", {}, a)
        );
      },
      addItem: function (a, b, d, e) {
        var f;
        return (
          null == b && (b = 1),
          null == d && (d = {}),
          null == e && (e = {}),
          (f = c.Utils.wrapKeys(d)),
          (f.id = a),
          (f.quantity = b),
          c.Queue.add("/cart/add.js", f, e),
          c.Core.getCart()
        );
      },
      updateItem: function (a, b, d, e) {
        var f;
        return (
          null == d && (d = {}),
          null == e && (e = {}),
          (f = c.Utils.wrapKeys(d)),
          (f.line = a),
          null != b && (f.quantity = b),
          (e.updateCart = !0),
          c.Queue.add("/cart/change.js", f, e)
        );
      },
      removeItem: function (a, b) {
        return null == b && (b = {}), c.Core.updateItem(a, 0, {}, b);
      },
      updateItemById: function (a, b, d, e) {
        var f;
        return (
          null == d && (d = {}),
          null == e && (e = {}),
          (f = c.Utils.wrapKeys(d)),
          (f.id = a),
          null != b && (f.quantity = b),
          (e.updateCart = !0),
          c.Queue.add("/cart/change.js", f, e)
        );
      },
      updateItemQuantitiesById: function (a, b) {
        return (
          null == a && (a = {}),
          null == b && (b = {}),
          (b.updateCart = !0),
          c.Queue.add("/cart/update.js", { updates: a }, b)
        );
      },
      removeItemById: function (a, b) {
        var d;
        return (
          null == b && (b = {}),
          (d = { id: a, quantity: 0 }),
          (b.updateCart = !0),
          c.Queue.add("/cart/change.js", d, b)
        );
      },
      clear: function (a) {
        return null == a && (a = {}), (a.updateCart = !0), c.Queue.add("/cart/clear.js", {}, a);
      },
      getAttribute: function (a, b) {
        return a in c.cart.attributes ? c.cart.attributes[a] : b;
      },
      setAttribute: function (a, b, d) {
        var e;
        return null == d && (d = {}), (e = {}), (e[a] = b), c.Core.setAttributes(e, d);
      },
      getAttributes: function () {
        return c.cart.attributes;
      },
      setAttributes: function (a, b) {
        return (
          null == a && (a = {}),
          null == b && (b = {}),
          (b.updateCart = !0),
          c.Queue.add("/cart/update.js", c.Utils.wrapKeys(a, "attributes"), b)
        );
      },
      clearAttributes: function (a) {
        return (
          null == a && (a = {}),
          (a.updateCart = !0),
          c.Queue.add(
            "/cart/update.js",
            c.Utils.wrapKeys(c.Core.getAttributes(), "attributes", ""),
            a
          )
        );
      },
      getNote: function () {
        return c.cart.note;
      },
      setNote: function (a, b) {
        return (
          null == b && (b = {}), (b.updateCart = !0), c.Queue.add("/cart/update.js", { note: a }, b)
        );
      },
    }),
    (a = null),
    (c.Data = {
      init: function () {
        return (a = jQuery(document)), c.Data.setEventListeners("on"), c.Data.render(null, c.cart);
      },
      destroy: function () {
        return c.Data.setEventListeners("off");
      },
      setEventListeners: function (b) {
        return (
          a[b]("click", "[data-cart-add]", c.Data.add),
          a[b]("click", "[data-cart-remove]", c.Data.remove),
          a[b]("click", "[data-cart-remove-id]", c.Data.removeById),
          a[b]("click", "[data-cart-update]", c.Data.update),
          a[b]("click", "[data-cart-update-id]", c.Data.updateById),
          a[b]("click", "[data-cart-clear]", c.Data.clear),
          a[b]("change", "[data-cart-toggle]", c.Data.toggle),
          a[b]("change", "[data-cart-toggle-attribute]", c.Data.toggleAttribute),
          a[b]("submit", "[data-cart-submit]", c.Data.submit),
          a[b]("cart.requestComplete", c.Data.render)
        );
      },
      add: function (a) {
        var b;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          c.Core.addItem(b.attr("data-cart-add"), b.attr("data-cart-quantity"))
        );
      },
      remove: function (a) {
        var b;
        return (
          a.preventDefault(), (b = jQuery(this)), c.Core.removeItem(b.attr("data-cart-remove"))
        );
      },
      removeById: function (a) {
        var b;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          c.Core.removeItemById(b.attr("data-cart-remove-id"))
        );
      },
      update: function (a) {
        var b;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          c.Core.updateItem(b.attr("data-cart-update"), b.attr("data-cart-quantity"))
        );
      },
      updateById: function (a) {
        var b;
        return (
          a.preventDefault(),
          (b = jQuery(this)),
          c.Core.updateItemById(b.attr("data-cart-update-id"), b.attr("data-cart-quantity"))
        );
      },
      clear: function (a) {
        return a.preventDefault(), c.Core.clear();
      },
      toggle: function () {
        var a, b;
        return (
          (a = jQuery(this)),
          (b = a.attr("data-cart-toggle")),
          a.is(":checked") ? c.Core.addItem(b) : c.Core.removeItemById(b)
        );
      },
      toggleAttribute: function () {
        var a, b;
        return (
          (a = jQuery(this)),
          (b = a.attr("data-cart-toggle-attribute")),
          c.Core.setAttribute(b, a.is(":checked") ? "Yes" : "")
        );
      },
      submit: function (a) {
        var b, d, e, f;
        return (
          a.preventDefault(),
          (b = jQuery(this).serializeArray()),
          (d = void 0),
          (f = void 0),
          (e = {}),
          jQuery.each(b, function (a, b) {
            return "id" === b.name
              ? (d = b.value)
              : "quantity" === b.name
              ? (f = b.value)
              : b.name.match(/^properties\[\w+\]$/)
              ? (e[b.name] = b.value)
              : void 0;
          }),
          c.Core.addItem(d, f, c.Utils.unwrapKeys(e))
        );
      },
      render: function (a, b) {
        var d;
        return (
          (d = {
            item_count: b.item_count,
            total_price: b.total_price,
            total_price_money: c.Utils.formatMoney(
              b.total_price,
              c.settings.moneyFormat,
              "money_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0
            ),
            total_price_money_with_currency: c.Utils.formatMoney(
              b.total_price,
              c.settings.moneyWithCurrencyFormat,
              "money_with_currency_format",
              null !=
                ("undefined" != typeof Currency && null !== Currency
                  ? Currency.currentCurrency
                  : void 0)
                ? Currency.currentCurrency
                : void 0
            ),
          }),
          jQuery("[data-cart-render]").each(function () {
            var a;
            return (a = jQuery(this)), a.html(d[a.attr("data-cart-render")]);
          })
        );
      },
    }),
    "rivets" in window
      ? ((c.Rivets = {
          model: null,
          boundViews: [],
          init: function () {
            return c.Rivets.bindViews();
          },
          destroy: function () {
            return c.Rivets.unbindViews();
          },
          bindViews: function () {
            return (
              c.Utils.log("Rivets.js is present, binding views."),
              c.Rivets.unbindViews(),
              (c.Rivets.model = c.Utils.extend({ cart: c.cart }, c.settings.rivetsModels)),
              null != window.Currency && (c.Rivets.model.Currency = window.Currency),
              jQuery("[data-cart-view]").each(function () {
                var a;
                return (a = rivets.bind(jQuery(this), c.Rivets.model)), c.Rivets.boundViews.push(a);
              })
            );
          },
          unbindViews: function () {
            var a, b, d, e;
            for (e = c.Rivets.boundViews, b = 0, d = e.length; d > b; b++) (a = e[b]), a.unbind();
            return (c.Rivets.boundViews = []);
          },
        }),
        (rivets.formatters.eq = function (a, b) {
          return a === b;
        }),
        (rivets.formatters.includes = function (a, b) {
          return a.indexOf(b) >= 0;
        }),
        (rivets.formatters.match = function (a, b, c) {
          return a.match(new RegExp(b, c));
        }),
        (rivets.formatters.lt = function (a, b) {
          return b > a;
        }),
        (rivets.formatters.gt = function (a, b) {
          return a > b;
        }),
        (rivets.formatters.not = function (a) {
          return !a;
        }),
        (rivets.formatters.empty = function (a) {
          return !a.length;
        }),
        (rivets.formatters.neq = function (a, b) {
          return a !== b;
        }),
        (rivets.formatters.plus = function (a, b) {
          return parseInt(a) + parseInt(b);
        }),
        (rivets.formatters.minus = function (a, b) {
          return parseInt(a) - parseInt(b);
        }),
        (rivets.formatters.times = function (a, b) {
          return a * b;
        }),
        (rivets.formatters.divided_by = function (a, b) {
          return a / b;
        }),
        (rivets.formatters.modulo = function (a, b) {
          return a % b;
        }),
        (rivets.formatters.prepend = function (a, b) {
          return b + a;
        }),
        (rivets.formatters.append = function (a, b) {
          return a + b;
        }),
        (rivets.formatters.slice = function (a, b, c) {
          return a.slice(b, c);
        }),
        (rivets.formatters.pluralize = function (a, b, d) {
          return null == d && (d = b + "s"), c.Utils.isArray(a) && (a = a.length), 1 === a ? b : d;
        }),
        (rivets.formatters.array_element = function (a, b) {
          return a[b];
        }),
        (rivets.formatters.array_first = function (a) {
          return a[0];
        }),
        (rivets.formatters.array_last = function (a) {
          return a[a.length - 1];
        }),
        (rivets.formatters.money = function (a, b) {
          return c.Utils.formatMoney(a, c.settings.moneyFormat, "money_format", b);
        }),
        (rivets.formatters.money_with_currency = function (a, b) {
          return c.Utils.formatMoney(
            a,
            c.settings.moneyWithCurrencyFormat,
            "money_with_currency_format",
            b
          );
        }),
        (rivets.formatters.weight = function (a) {
          switch (c.settings.weightUnit) {
            case "kg":
              return (a / 1e3).toFixed(c.settings.weightPrecision);
            case "oz":
              return (0.035274 * a).toFixed(c.settings.weightPrecision);
            case "lb":
              return (0.00220462 * a).toFixed(c.settings.weightPrecision);
            default:
              return a.toFixed(c.settings.weightPrecision);
          }
        }),
        (rivets.formatters.weight_with_unit = function (a) {
          return rivets.formatters.weight(a) + c.settings.weightUnit;
        }),
        (rivets.formatters.product_image_size = function (a, b) {
          return c.Utils.getSizedImageUrl(a, b);
        }),
        (rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency),
        (rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit),
        (rivets.formatters.productImageSize = rivets.formatters.product_image_size))
      : (c.Rivets = { init: function () {}, destroy: function () {} }),
    (c.factory = function (a) {
      return (
        (a.init = c.init),
        (a.configure = c.configure),
        (a.cart = c.cart),
        (a.settings = c.settings),
        (a.getCart = c.Core.getCart),
        (a.addItem = c.Core.addItem),
        (a.updateItem = c.Core.updateItem),
        (a.updateItemById = c.Core.updateItemById),
        (a.updateItemQuantitiesById = c.Core.updateItemQuantitiesById),
        (a.removeItem = c.Core.removeItem),
        (a.removeItemById = c.Core.removeItemById),
        (a.clear = c.Core.clear),
        (a.getAttribute = c.Core.getAttribute),
        (a.setAttribute = c.Core.setAttribute),
        (a.getAttributes = c.Core.getAttributes),
        (a.setAttributes = c.Core.setAttributes),
        (a.clearAttributes = c.Core.clearAttributes),
        (a.getNote = c.Core.getNote),
        (a.setNote = c.Core.setNote),
        (a.render = c.Data.render)
      );
    }),
    "object" == typeof exports
      ? c.factory(exports)
      : "function" == typeof define && define.amd
      ? define(["exports"], function (a) {
          return c.factory((this.CartJS = a)), a;
        })
      : c.factory((this.CartJS = {}));
}).call(this);

(function ($) {
  var $firstLetter;
  var $secondLetter;
  var $thirdLetter;

  var stitchColor;
  var $monogramStyle = "circle";

  var monogramCircle = [
    //First Letter
    {
      a: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/A.png?10436166205336198244">',
      b: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/B.png?10436166205336198244">',
      c: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/C.png?10436166205336198244">',
      d: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/D.png?v=1613795653">',
      e: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/E.png?10436166205336198244">',
      f: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/F.png?10436166205336198244">',
      g: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/G.png?10436166205336198244">',
      h: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/H.png?10436166205336198244">',
      i: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/I.png?10436166205336198244">',
      j: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/J.png?10436166205336198244">',
      k: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/K.png?10436166205336198244">',
      l: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/L.png?10436166205336198244">',
      m: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/M.png?10436166205336198244">',
      n: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/N.png?10436166205336198244">',
      o: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/O.png?10436166205336198244">',
      p: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/P.png?10436166205336198244">',
      q: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Q.png?10436166205336198244">',
      r: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/R.png?10436166205336198244">',
      s: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/S.png?10436166205336198244">',
      t: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/T.png?10436166205336198244">',
      u: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/U.png?10436166205336198244">',
      v: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/V.png?10436166205336198244">',
      w: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/W.png?10436166205336198244">',
      x: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/X.png?10436166205336198244">',
      y: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Y.png?10436166205336198244">',
      z: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Z.png?10436166205336198244">',
    },
    //Middle Letter
    {
      a: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/A_393906ce-6d44-4f94-ad86-540f4499ddd3.png?1621742486005683723">',
      b: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/B_9b527a79-c83d-48ea-b66b-bde50625fb41.png?1621742486005683723">',
      c: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/C_73e40bde-eb23-4dce-a951-042b745eb2f0.png?1621742486005683723">',
      d: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/D_middle_new.png?v=1710985487">',
      e: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/E_8a80f172-8c29-4996-b5fe-c22b38ccdbc6.png?1621742486005683723">',
      f: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/F_47d93825-2bfa-445f-a94d-c2bd2678fc00.png?1621742486005683723">',
      g: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/G_26825784-bbe0-4c3a-9cc0-d1305dedc7fb.png?1621742486005683723">',
      h: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/H_041abce9-3946-4fe9-b139-6e6bab63e547.png?1621742486005683723">',
      i: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/I_0bb23e03-48cb-4935-8842-5033f8ba5cfe.png?1621742486005683723">',
      j: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/J_5b9553ba-f068-432c-b3b0-975f2ec4a4a3.png?1621742486005683723">',
      k: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/K_afc1f9c6-5149-49c1-9ff6-28072899b5a0.png?1621742486005683723">',
      l: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/L_b1d7d36f-a7d0-4a49-a1e7-39b73e6875f6.png?1621742486005683723">',
      m: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/M_5152c93c-2fe4-46d3-82a7-b94620e81ac9.png?1621742486005683723">',
      n: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/N_bb9c49d9-e150-4eb2-8299-9bbf33061772.png?1621742486005683723">',
      o: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/O_92203f2a-2730-4243-8062-4d5ac31aa306.png?1621742486005683723">',
      p: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/P_f3a160e4-7115-4062-889b-0e396d5294dc.png?1621742486005683723">',
      q: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Q_1d3eca9c-2603-4671-a7f3-5367a973e879.png?1621742486005683723">',
      r: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/R_758fdcbe-3aa2-40af-a866-41dc03f499f4.png?1621742486005683723">',
      s: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/S_dca861ae-3cef-4d15-88dc-fe0d3d5da443.png?1621742486005683723">',
      t: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/T_0f351488-6ef0-40e4-b3c4-736501a3635f.png?1621742486005683723">',
      u: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/U_7125130b-d28d-4ee2-be5f-afd104ce5459.png?1621742486005683723">',
      v: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/V_1d204101-fc24-4abd-9ff7-048b8dffa5ec.png?1621742486005683723">',
      w: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/W_7229bdd1-3e37-4ce8-aa58-a458a2f07640.png?1621742486005683723">',
      x: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/X_9ba51169-a201-41df-9c63-df06e2433b23.png?1621742486005683723">',
      y: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Y_ff303aab-b1f3-4fcf-a5ac-3ca13d7f3ca6.png?1621742486005683723">',
      z: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Z_1993f70f-db71-40ef-930c-8eb819ad47cf.png?1621742486005683723">',
    },
    //Last Letter
    {
      a: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/A_092400af-1ddd-41c3-ab41-a585a27769b3.png?2682781832619592106">',
      b: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/B_c9f0a7a5-ce79-40cf-bcec-ee31df5d7517.png?2682781832619592106">',
      c: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/C_9c49a8b0-a262-42fb-aeeb-a867ad0a74a9.png?2682781832619592106">',
      d: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/D_ce4567dd-2003-47ed-a6aa-52292fe483cc.png?v=1613795657">',
      e: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/E_bee01d44-ece4-489f-aa37-74e66bb9dab6.png?2682781832619592106">',
      f: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/F_2177c3bb-0a47-4b98-9df9-c88d33c2bfa5.png?2682781832619592106">',
      g: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/G_e0dec232-a37c-4751-9ea6-a34ec2ad4cc2.png?2682781832619592106">',
      h: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/H_e18c640f-f9b6-4724-9d1b-790fc05b75fb.png?2682781832619592106">',
      i: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/I_d15a0d15-98cf-4e04-9bb6-865d52c3b9f3.png?2682781832619592106">',
      j: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/J_f1b2a7c2-7296-4640-ac00-e862848f6080.png?2682781832619592106">',
      k: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MONOGRAM-K.png?v=1608063159">',
      l: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/L_57341365-0d59-4065-9521-ee622fcd7087.png?2682781832619592106">',
      m: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/M_a7e020a2-d20f-42b4-9563-44c04453ec08.png?2682781832619592106">',
      n: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/N_461d69c1-191a-4a9c-9b8d-965ff5ba2336.png?2682781832619592106">',
      o: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/O_e5deb8a1-07a7-4702-84fb-95084c1c9bbd.png?2682781832619592106">',
      p: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/P_1d1eb363-c438-426f-a3de-a4cc64d423f0.png?2682781832619592106">',
      q: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Q_dfcca0e1-4d4f-4498-a02b-3f64bcb0cc98.png?2682781832619592106">',
      r: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/R_4c810792-b9d9-4937-81be-88e58e2b72e5.png?2682781832619592106">',
      s: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/S_d0dffd17-65e7-48ec-b2c2-9b4cf186533f.png?2682781832619592106">',
      t: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/T_1d43ce17-7d95-4f4e-80d0-e13a114d316e.png?2682781832619592106">',
      u: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/U_ed866635-5aca-4025-a9c2-57e5cadcad85.png?2682781832619592106">',
      v: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/V_58309fa3-3643-42b4-85bd-995b13cec514.png?2682781832619592106">',
      w: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/W_1c28dc71-63d1-41a0-92d6-c8dada35ae3f.png?2682781832619592106">',
      x: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/X_6f3d47a4-d65e-44b2-a1f9-48f437cf2c11.png?2682781832619592106">',
      y: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Y_c186b473-9d66-44d9-8764-71449e14da2a.png?2682781832619592106">',
      z: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Z_db099477-f528-451f-803c-97a4aac39f07.png?2682781832619592106">',
    },
  ];

  var monogramDiamond = [
    {
      a: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/A_265fb744-bec1-4f4c-bf25-ce71b6257bcf.png?10271146114699984936">',
      b: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/B_aff4fb78-f7f1-4b33-9df9-f7290cd7e2c5.png?10271146114699984936">',
      c: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/C_a505b57d-aba3-4427-85e2-aec6ee71a61a.png?10271146114699984936">',
      d: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/D_9034c0fc-e353-4dd9-a87d-501c93c84d70.png?10271146114699984936">',
      e: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/E_6032941a-2943-4591-96bc-649ab91bf012.png?10271146114699984936">',
      f: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/F_a2b185d3-7aeb-4ad8-a63c-1599a9e0a2a2.png?10271146114699984936">',
      g: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/G_d4884748-ee9e-4e84-8bf4-6f288866666b.png?10271146114699984936">',
      h: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/H_8a363055-8f0f-4a61-81fb-2ec4dab51e3a.png?10271146114699984936">',
      i: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/I_658cd008-fe0f-4cf6-87f5-86171980a14a.png?10271146114699984936">',
      j: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/J_830529d8-d399-447e-b456-99ebc5ca416e.png?10271146114699984936">',
      k: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/K_28ea4871-bcf3-40e6-b4cf-15fcda4deb50.png?10271146114699984936">',
      l: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/L_67c22cf4-467f-464f-8de1-9f2d6fa16b6a.png?10271146114699984936">',
      m: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/M_1f7c4ad0-a7e1-49ed-a73a-0126f00677c3.png?10271146114699984936">',
      n: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/N_6cd0f2e1-beda-4f5b-9599-ea754e943c77.png?10271146114699984936">',
      o: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/O_755fb0d4-69b4-4b44-8eb4-1aa4ae2b1a62.png?10271146114699984936">',
      p: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/P_0d7aa509-143a-4f2e-9454-92217bc6f9e7.png?10271146114699984936">',
      q: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Q_bea75ed3-4a2a-4a41-b52e-c7d80eae823a.png?10271146114699984936">',
      r: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/R_84a0e0da-453d-4a63-b9ad-f73d9369f990.png?10271146114699984936">',
      s: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/S_b225d5fa-bd14-4d54-be90-9000c1a5684c.png?10271146114699984936">',
      t: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/T_e4b8db5f-5ec2-4f31-bac8-a201485f3ec2.png?10271146114699984936">',
      u: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/U_79ad0ac3-8b99-483a-83bc-c2f2701395dd.png?10271146114699984936">',
      v: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/V_a18d5573-9f4c-4e74-aef7-90048bc76757.png?10271146114699984936">',
      w: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/W_4ed74ad0-59e2-42e2-a187-bdf0f87713fd.png?10271146114699984936">',
      x: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/X_4d1ba638-4852-458a-a512-c6c2b5027fff.png?10271146114699984936">',
      y: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Y_c4eccfc4-429c-4c3c-afd6-99d3f62b6a9d.png?10271146114699984936">',
      z: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Z_44b58f3a-18f3-42d1-95ee-02aac178f8f0.png?v=1623350290">',
    },
    //Middle Letter
    {
      a: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/A_2f9bab7a-66a3-47f6-ad14-66c06d2886d5.png?16952739213019283926">',
      b: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/B_f08c63f5-f4fb-48f7-bd65-a3cbbf2fb12d.png?16952739213019283926">',
      c: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/C_49b34fec-97a7-4439-ac82-464e8d19aa15.png?16952739213019283926">',
      d: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/D_26fb4572-286e-444c-89a0-2d8ff004d790.png?16952739213019283926">',
      e: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/E_eab799fb-3c65-4196-b600-e61176c8ae2f.png?16952739213019283926">',
      f: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/F_973ee076-5df9-4a02-8e76-75c3e07defd3.png?16952739213019283926">',
      g: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/G_b376ea6c-e57b-4a2a-a549-5a9983b7dfe0.png?16952739213019283926">',
      h: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/H_43ae0a4d-6294-4a90-a268-c5df26c93cb0.png?16952739213019283926">',
      i: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/I_0138877a-131d-4876-a7d7-4cb96ce72be6.png?16952739213019283926">',
      j: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/J_9c82eb10-e75c-46f5-9ce3-c718d9db66bb.png?16952739213019283926">',
      k: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/K_ae654420-96ce-4a36-877e-501ed783341e.png?16952739213019283926">',
      l: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/L_b69cf7eb-d29e-4a44-9c31-b01399fb8a30.png?16952739213019283926">',
      m: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/M_33417065-9cf4-44cf-a9d3-d177f435bfb8.png?16952739213019283926">',
      n: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/N_6cbbc9f6-9e4c-41df-a579-a2dffb72d731.png?16952739213019283926">',
      o: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/O_644b3588-d82a-49c6-b078-54508bfec9e9.png?16952739213019283926">',
      p: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/P_20b31583-3abd-4d0e-b1b0-55b60ddbe10e.png?16952739213019283926">',
      q: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Q_539cf074-317a-477f-bad4-e0656f58f126.png?16952739213019283926">',
      r: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/R_a6abb2ce-1e56-4e07-9f97-9451f3436f3c.png?16952739213019283926">',
      s: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/S_8848233e-7ab8-41ef-8706-27e73cd0148c.png?16952739213019283926">',
      t: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/T_d2354e6e-b7e3-4eb8-814a-99d9718e3de0.png?16952739213019283926">',
      u: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/U_7af8a2bf-ced0-4990-920b-4c36e235a1c9.png?16952739213019283926">',
      v: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/V_53de0b44-aa7e-48f8-997c-ff04aa435114.png?16952739213019283926">',
      w: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/W_7094bc20-b6f5-466c-87aa-33a7107f75d1.png?16952739213019283926">',
      x: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/X_52e6f35b-96fb-46bc-a2a8-795a1c8b20e4.png?16952739213019283926">',
      y: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Y_7c770043-85c8-47cb-9783-cc4b58b0c9bb.png?16952739213019283926">',
      z: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Z_ee47072c-1eed-48e1-b591-f41e77b4e064.png?16952739213019283926">',
    },
    //Last Letter
    {
      a: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/A_7d76ef13-9e48-44cc-9151-5b9517de95ac.png?71749486779555454">',
      b: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/B_0069001e-1379-4b7b-bce2-2f4da72625fe.png?71749486779555454">',
      c: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/C_768b1cc5-ae67-43a5-b798-039cb1552f6a.png?71749486779555454">',
      d: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/D_ef67a5d7-f726-43a5-b8c0-0ea2fb0fa4e7.png?71749486779555454">',
      e: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/E_e3d2bcdd-15ce-4fde-8b41-aa60780db63c.png?71749486779555454">',
      f: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/F_f4eed9fe-6b28-46e2-b5a7-48a7678d03e9.png?71749486779555454">',
      g: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/G_5d083667-7cb8-4fb6-982f-9608219f9ed8.png?71749486779555454">',
      h: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/H_eed5dd81-8f6c-45f0-a48d-d168b8a5f131.png?71749486779555454">',
      i: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/I_bee234be-b83e-4438-988a-bfba64c66671.png?71749486779555454">',
      j: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/J_c39abd0a-9160-4adf-8683-0cb9bcf3c918.png?71749486779555454">',
      k: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/K_80a0f4e4-8d7e-4d22-b4e2-16e5edf79c0f.png?71749486779555454">',
      l: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/L_f48bb339-2076-4266-b3ef-254058d15e50.png?71749486779555454">',
      m: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/M_5cd4df37-605c-4397-b808-2b3e86e6d91c.png?71749486779555454">',
      n: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/N_53b76d13-ae01-48e0-a47f-84c6af37309c.png?71749486779555454">',
      o: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/O_f0052916-d7c4-401a-8de8-7a34a1bd2e02.png?71749486779555454">',
      p: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/P_e67bced6-2a76-46bf-a488-00c2276c2b3c.png?71749486779555454">',
      q: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Q_f18b4cf4-3c3c-49ad-9404-4f5b46cff640.png?71749486779555454">',
      r: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/R_8b4786cb-5aa0-4167-ab0e-19b78d7e64dd.png?71749486779555454">',
      s: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/S_ccb2b54a-3f48-4ddc-ab96-d5af740f5f94.png?71749486779555454">',
      t: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/T_f95929b9-80eb-49ce-b5e1-7aa5a96ee3f9.png?71749486779555454">',
      u: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/U_b0cec675-fb9f-40f6-ab4b-d697d2f687a2.png?71749486779555454">',
      v: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/V_a812141c-f34c-4e0f-be79-38c913fc2b0a.png?71749486779555454">',
      w: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/W_529e64e3-f2d3-43ad-b252-f9c9c37d0c1c.png?71749486779555454">',
      x: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/X_fb42dd65-a559-48c5-965d-76a19bea7be8.png?71749486779555454">',
      y: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Y_8416f486-d905-4a37-8550-ed3ecb22daa6.png?71749486779555454">',
      z: '<img alt="monogram image" src="https://cdn.shopify.com/s/files/1/0035/0306/3153/files/Z_c01846cb-a295-4722-8f75-e6d9ef117e90.png?71749486779555454">',
    },
  ];

  function customJack() {
    //This contains all the combination and handles
    var variants = [
      {
        color: "Black",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20black_201000x872_1024x1024.jpg?v=1543512882",
        handle: "custom-jacks-sandal-medium-black-black",
      },
      {
        color: "Black",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_blush_1024x1024.jpg?v=1543513917",
        handle: "custom-jacks-sandal-medium-black-blush",
      },
      {
        color: "Black",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20bone_201000x872_1024x1024.jpg?v=1543513000",
        handle: "custom-jacks-sandal-medium-black-bone",
      },
      {
        color: "Black",
        pattern: "Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20pink_201000x872_1024x1024.jpg?v=1543513900",
        handle: "custom-jacks-sandal-medium-black-pink",
      },
      {
        color: "Black",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black-brightpink_1024x1024.jpg?v=1543513982",
        handle: "custom-jacks-sandal-medium-black-bright-pink",
      },
      {
        color: "Black",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20carribeanblue_201000x872_1024x1024.jpg?v=1543513085",
        handle: "custom-jacks-sandal-medium-black-caribbean-blue",
      },
      {
        color: "Black",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_dkorange_1024x1024.jpg?v=1543513977",
        handle: "custom-jacks-sandal-medium-black-dark-orange",
      },
      {
        color: "Black",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black-garnet_1024x1024.jpg?v=1543513171",
        handle: "custom-jacks-sandal-medium-black-garnet",
      },
      {
        color: "Black",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20gold_201000x872_1024x1024.jpg?v=1543512876",
        handle: "custom-jacks-sandal-medium-black-gold",
      },
      {
        color: "Black",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_green_1024x1024.jpg?v=1543513967",
        handle: "custom-jacks-sandal-medium-black-green",
      },
      {
        color: "Black",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_lightblue_1024x1024.jpg?v=1543513162",
        handle: "custom-jacks-sandal-medium-black-light-blue",
      },
      {
        color: "Black",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20navy_201000x872_1024x1024.jpg?v=1543513972",
        handle: "custom-jacks-sandal-medium-black-midnight",
      },
      {
        color: "Black",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20platinum_201000x872_1024x1024.jpg?v=1543513089",
        handle: "custom-jacks-sandal-medium-black-platinum",
      },
      {
        color: "Black",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_purple_1024x1024.jpg?v=1543513093",
        handle: "custom-jacks-sandal-medium-black-purple",
      },
      {
        color: "Black",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_red_1024x1024.jpg?v=1543513097",
        handle: "custom-jacks-sandal-medium-black-red",
      },
      {
        color: "Black",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20silver_201000x872_1024x1024.jpg?v=1543513101",
        handle: "custom-jacks-sandal-medium-black-silver",
      },
      {
        color: "Black",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/black_20white_201000x872_1024x1024.jpg?v=1543512871",
        handle: "custom-jacks-sandal-medium-black-white",
      },
      {
        color: "Black",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_black_yellow_1024x1024.jpg?v=1543513106",
        handle: "custom-jacks-sandal-medium-black-yellow",
      },
      {
        color: "Blush",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_black_1024x1024.jpg?v=1543513922",
        handle: "custom-jacks-sandal-medium-blush-black",
      },
      {
        color: "Blush",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_blush_1024x1024.jpg?v=1543513913",
        handle: "custom-jacks-sandal-medium-blush-blush",
      },
      {
        color: "Blush",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_bone_1024x1024.jpg?v=1543513786",
        handle: "custom-jacks-sandal-medium-blush-bone",
      },
      {
        color: "Blush",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_brightpink_1024x1024.jpg?v=1543513635",
        handle: "custom-jacks-sandal-medium-blush-bright-pink",
      },
      {
        color: "Blush",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_caribblue_1024x1024.jpg?v=1543513790",
        handle: "custom-jacks-sandal-medium-blush-caribbean-blue",
      },
      {
        color: "Blush",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_dkorange_1024x1024.jpg?v=1543513776",
        handle: "custom-jacks-sandal-medium-blush-dark-orange",
      },
      {
        color: "Blush",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_garnet_1024x1024.jpg?v=1543513801",
        handle: "custom-jacks-sandal-medium-blush-garnet",
      },
      {
        color: "Blush",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_gold_1024x1024.jpg?v=1543513771",
        handle: "custom-jacks-sandal-medium-blush-gold",
      },
      {
        color: "Blush",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_lightblue_1024x1024.jpg?v=1543513314",
        handle: "custom-jacks-sandal-medium-blush-light-blue",
      },
      {
        color: "Blush",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_midnight_1024x1024.jpg?v=1543513927",
        handle: "custom-jacks-sandal-medium-blush-midnight",
      },
      {
        color: "Blush",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_platinum_1024x1024.jpg?v=1543513895",
        handle: "custom-jacks-sandal-medium-blush-platinum",
      },
      {
        color: "Blush",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_purple_1024x1024.jpg?v=1543513815",
        handle: "custom-jacks-sandal-medium-blush-purple",
      },
      {
        color: "Blush",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_red_1024x1024.jpg?v=1543513797",
        handle: "custom-jacks-sandal-medium-blush-red",
      },
      {
        color: "Blush",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_silver_1024x1024.jpg?v=1543513810",
        handle: "custom-jacks-sandal-medium-blush-silver",
      },
      {
        color: "Blush",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_white_1024x1024.jpg?v=1543513744",
        handle: "custom-jacks-sandal-medium-blush-white",
      },
      {
        color: "Blush",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_blush_yellow_1024x1024.jpg?v=1543513819",
        handle: "custom-jacks-sandal-medium-blush-yellow",
      },
      {
        color: "Bone",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20black_201000x872_1024x1024.jpg?v=1543513886",
        handle: "custom-jacks-sandal-medium-bone-black",
      },
      {
        color: "Bone",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_bone_blush_1024x1024.jpg?v=1543513386",
        handle: "custom-jacks-sandal-medium-bone-blush",
      },
      {
        color: "Bone",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20bone_201000x872_1024x1024.jpg?v=1543513361",
        handle: "custom-jacks-sandal-medium-bone-bone",
      },
      {
        color: "Bone",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20caribbeanblue_201000x872_1024x1024.jpg?v=1543513951",
        handle: "custom-jacks-sandal-medium-bone-caribbean-blue",
      },
      {
        color: "Bone",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20orange_201000x872_1024x1024.jpg?v=1543513936",
        handle: "custom-jacks-sandal-medium-bone-dark-orange",
      },
      {
        color: "Bone",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_bone-garnet_1024x1024.jpg?v=1543513370",
        handle: "custom-jacks-sandal-medium-bone-garnet",
      },
      {
        color: "Bone",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20gold_201000x872_1024x1024.jpg?v=1543513904",
        handle: "custom-jacks-sandal-medium-bone-gold",
      },
      {
        color: "Bone",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20kelly_201000x872_1024x1024.jpg?v=1543513946",
        handle: "custom-jacks-sandal-medium-bone-green",
      },
      {
        color: "Bone",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_bone_lightblue_1024x1024.jpg?v=1543513396",
        handle: "custom-jacks-sandal-medium-bone-light-blue",
      },
      {
        color: "Bone",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20navy_201000x872_1024x1024.jpg?v=1543513956",
        handle: "custom-jacks-sandal-medium-bone-midnight",
      },
      {
        color: "Bone",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20platinum_201000x872_1024x1024.jpg?v=1543513400",
        handle: "custom-jacks-sandal-medium-bone-platinum",
      },
      {
        color: "Bone",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20purple_201000x872_1024x1024.jpg?v=1543513962",
        handle: "custom-jacks-sandal-medium-bone-purple",
      },
      {
        color: "Bone",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20red_201000x872_1024x1024.jpg?v=1543513932",
        handle: "custom-jacks-sandal-medium-bone-red",
      },
      {
        color: "Bone",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20silver_201000x872_1024x1024.jpg?v=1543513380",
        handle: "custom-jacks-sandal-medium-bone-silver",
      },
      {
        color: "Bone",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_bone_white_1024x1024.jpg?v=1543513375",
        handle: "custom-jacks-sandal-medium-bone-white",
      },
      {
        color: "Bone",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_bone-garnet_1024x1024.jpg?v=1543513370",
        handle: "custom-jacks-sandal-medium-bone-garnet",
      },
      {
        color: "Bone",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/bone_20yellow_201000x872_1024x1024.jpg?v=1543513941",
        handle: "custom-jacks-sandal-medium-bone-yellow",
      },
      {
        color: "Bright-Pink",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-black_1024x1024.jpg?v=1543514152",
        handle: "custom-jacks-sandal-medium-bright-pink-black",
      },
      {
        color: "Bright-Pink",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink_blush_1024x1024.jpg?v=1543513748",
        handle: "custom-jacks-sandal-medium-bright-pink-blush",
      },
      {
        color: "Bright-Pink",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-bone_1024x1024.jpg?v=1543513766",
        handle: "custom-jacks-sandal-medium-bright-pink-bone",
      },
      {
        color: "Bright-Pink",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink_brightpink_1024x1024.jpg?v=1543513736",
        handle: "custom-jacks-sandal-medium-bright-pink-bright-pink",
      },
      {
        color: "Bright-Pink",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-caribblue_1024x1024.jpg?v=1543514156",
        handle: "custom-jacks-sandal-medium-bright-pink-caribbean-blue",
      },
      {
        color: "Bright-Pink",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink_orange_1024x1024.jpg?v=1543514165",
        handle: "custom-jacks-sandal-medium-bright-pink-dark-orange",
      },
      {
        color: "Bright-Pink",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-garnet_1024x1024.jpg?v=1543513752",
        handle: "custom-jacks-sandal-medium-bright-pink-garnet",
      },
      {
        color: "Bright-Pink",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-gold_1024x1024.jpg?v=1543513722",
        handle: "custom-jacks-sandal-medium-bright-pink-gold",
      },
      {
        color: "Bright-Pink",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-green_1024x1024.jpg?v=1543514161",
        handle: "custom-jacks-sandal-medium-bright-pink-green",
      },
      {
        color: "Bright-Pink",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink_lightblue_1024x1024.jpg?v=1543514233",
        handle: "custom-jacks-sandal-medium-bright-pink-light-blue",
      },
      {
        color: "Bright-Pink",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink_midnight_1024x1024.jpg?v=1543513717",
        handle: "custom-jacks-sandal-medium-bright-pink-midnight",
      },
      {
        color: "Bright-Pink",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-platinum_1024x1024.jpg?v=1543513726",
        handle: "custom-jacks-sandal-medium-bright-pink-platinum",
      },
      {
        color: "Bright-Pink",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-purple_1024x1024.jpg?v=1543514169",
        handle: "custom-jacks-sandal-medium-bright-pink-purple",
      },
      {
        color: "Bright-Pink",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-red_1024x1024.jpg?v=1543514173",
        handle: "custom-jacks-sandal-medium-bright-pink-red",
      },
      {
        color: "Bright-Pink",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-silver_1024x1024.jpg?v=1543513757",
        handle: "custom-jacks-sandal-medium-bright-pink-silver",
      },
      {
        color: "Bright-Pink",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-white_1024x1024.jpg?v=1543513731",
        handle: "custom-jacks-sandal-medium-bright-pink-white",
      },
      {
        color: "Bright-Pink",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_brightpink-yellow_1024x1024.jpg?v=1543513761",
        handle: "custom-jacks-sandal-medium-bright-pink-yellow",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20black_201000x872_1024x1024.jpg?v=1543513110",
        handle: "custom-jacks-sandal-medium-caribbean-blue-black",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_caribblue_blush_1024x1024.jpg?v=1543513543",
        handle: "custom-jacks-sandal-medium-caribbean-blue-blush",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/caribbeanblue_20bone_201000x872_1024x1024.jpg?v=1543513004",
        handle: "custom-jacks-sandal-medium-caribbean-blue-bone",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_caribblue-brightpink_1024x1024.jpg?v=1543514000",
        handle: "custom-jacks-sandal-medium-caribbean-blue-bright-pink",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20carribeanblue_201000x872_1024x1024.jpg?v=1543513041",
        handle: "custom-jacks-sandal-medium-caribbean-blue-caribbean-blue",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_dkorange_701d04ca-458e-48dd-9efd-b62ce124a81e_1024x1024.jpg?v=1543513996",
        handle: "custom-jacks-sandal-medium-caribbean-blue-dark-orange",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_caribblue-garnet_1024x1024.jpg?v=1543513547",
        handle: "custom-jacks-sandal-medium-caribbean-blue-garnet",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20gold_201000x872_1024x1024.jpg?v=1543513117",
        handle: "custom-jacks-sandal-medium-caribbean-blue-gold",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_caribblue_green_1024x1024.jpg?v=1543513991",
        handle: "custom-jacks-sandal-medium-caribbean-blue-green",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_carribblue_lightblue_1024x1024.jpg?v=1543513551",
        handle: "custom-jacks-sandal-medium-caribbean-blue-light-blue",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20navy_201000x872_1024x1024.jpg?v=1543514225",
        handle: "custom-jacks-sandal-medium-caribbean-blue-midnight",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20platinum_201000x872_1024x1024.jpg?v=1543513080",
        handle: "custom-jacks-sandal-medium-caribbean-blue-platinum",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20silver_201000x872_1024x1024.jpg?v=1543513132",
        handle: "custom-jacks-sandal-medium-caribbean-blue-silver",
      },
      {
        color: "Caribbean-Blue",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/carribeanblue_20white_201000x872_1024x1024.jpg?v=1543513137",
        handle: "custom-jacks-sandal-medium-caribbean-blue-white",
      },
      {
        color: "Caribbean-Blue",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_caribblue_yellow_1024x1024.jpg?v=1543513141",
        handle: "custom-jacks-sandal-medium-caribbean-blue-yellow",
      },
      {
        color: "Dark-Orange",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_black_1024x1024.jpg?v=1543514124",
        handle: "custom-jacks-sandal-medium-dark-orange-black",
      },
      {
        color: "Dark-Orange",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_blush_1024x1024.jpg?v=1543513867",
        handle: "custom-jacks-sandal-medium-dark-orange-blush",
      },
      {
        color: "Dark-Orange",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_bone_1024x1024.jpg?v=1543513881",
        handle: "custom-jacks-sandal-medium-dark-orange-bone",
      },
      {
        color: "Dark-Orange",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_brightpink_1024x1024.jpg?v=1543514136",
        handle: "custom-jacks-sandal-medium-dark-orange-bright-pink",
      },
      {
        color: "Dark-Orange",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_caribblue_1024x1024.jpg?v=1543514128",
        handle: "custom-jacks-sandal-medium-dark-orange-caribbean-blue",
      },
      {
        color: "Dark-Orange",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_dkorange_1024x1024.jpg?v=1543514120",
        handle: "custom-jacks-sandal-medium-dark-orange-dark-orange",
      },
      {
        color: "Dark-Orange",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_garnet_1024x1024.jpg?v=1543513872",
        handle: "custom-jacks-sandal-medium-dark-orange-garnet",
      },
      {
        color: "Dark-Orange",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_gold_1024x1024.jpg?v=1543513310",
        handle: "custom-jacks-sandal-medium-dark-orange-gold",
      },
      {
        color: "Dark-Orange",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_green_1024x1024.jpg?v=1543514132",
        handle: "custom-jacks-sandal-medium-dark-orange-green",
      },
      {
        color: "Dark-Orange",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_lightblue_1024x1024.jpg?v=1543513876",
        handle: "custom-jacks-sandal-medium-dark-orange-light-blue",
      },
      {
        color: "Dark-Orange",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_midnight_1024x1024.jpg?v=1543513254",
        handle: "custom-jacks-sandal-medium-dark-orange-midnight",
      },
      {
        color: "Dark-Orange",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_platinum_1024x1024.jpg?v=1543513859",
        handle: "custom-jacks-sandal-medium-dark-orange-platinum",
      },
      {
        color: "Dark-Orange",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_purple_1024x1024.jpg?v=1543513319",
        handle: "custom-jacks-sandal-medium-dark-orange-purple",
      },
      {
        color: "Dark-Orange",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_red_1024x1024.jpg?v=1543514140",
        handle: "custom-jacks-sandal-medium-dark-orange-red",
      },
      {
        color: "Dark-Orange",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_silver_1024x1024.jpg?v=1543514144",
        handle: "custom-jacks-sandal-medium-dark-orange-silver",
      },
      {
        color: "Dark-Orange",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_white_1024x1024.jpg?v=1543513855",
        handle: "custom-jacks-sandal-medium-dark-orange-white",
      },
      {
        color: "Dark-Orange",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_dkorange_yellow_1024x1024.jpg?v=1543514149",
        handle: "custom-jacks-sandal-medium-dark-orange-yellow",
      },
      {
        color: "Garnet",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-black_1024x1024.jpg?v=1543513245",
        handle: "custom-jacks-sandal-medium-garnet-black",
      },
      {
        color: "Garnet",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-blush_1024x1024.jpg?v=1543513649",
        handle: "custom-jacks-sandal-medium-garnet-blush",
      },
      {
        color: "Garnet",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-bone_1024x1024.jpg?v=1543513662",
        handle: "custom-jacks-sandal-medium-garnet-bone",
      },
      {
        color: "Garnet",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-brightpink_1024x1024.jpg?v=1543513672",
        handle: "custom-jacks-sandal-medium-garnet-bright-pink",
      },
      {
        color: "Garnet",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-caribblue_1024x1024.jpg?v=1543513639",
        handle: "custom-jacks-sandal-medium-garnet-caribbean-blue",
      },
      {
        color: "Garnet",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet_dkorange_1024x1024.jpg?v=1543513667",
        handle: "custom-jacks-sandal-medium-garnet-dark-orange",
      },
      {
        color: "Garnet",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet_garnet_1024x1024.jpg?v=1543513644",
        handle: "custom-jacks-sandal-medium-garnet-garnet",
      },
      {
        color: "Garnet",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-gold_1024x1024.jpg?v=1543513249",
        handle: "custom-jacks-sandal-medium-garnet-gold",
      },
      {
        color: "Garnet",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-green_1024x1024.jpg?v=1543513681",
        handle: "custom-jacks-sandal-medium-garnet-green",
      },
      {
        color: "Garnet",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet_lightblue_1024x1024.jpg?v=1543513657",
        handle: "custom-jacks-sandal-medium-garnet-light-blue",
      },
      {
        color: "Garnet",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-midnight_1024x1024.jpg?v=1543513653",
        handle: "custom-jacks-sandal-medium-garnet-midnight",
      },
      {
        color: "Garnet",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-platinum_1024x1024.jpg?v=1543513630",
        handle: "custom-jacks-sandal-medium-garnet-platinum",
      },
      {
        color: "Garnet",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-purple_1024x1024.jpg?v=1543513687",
        handle: "custom-jacks-sandal-medium-garnet-purple",
      },
      {
        color: "Garnet",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-red_1024x1024.jpg?v=1543513676",
        handle: "custom-jacks-sandal-medium-garnet-red",
      },
      {
        color: "Garnet",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-silver_1024x1024.jpg?v=1543513263",
        handle: "custom-jacks-sandal-medium-garnet-silver",
      },
      {
        color: "Garnet",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-white_1024x1024.jpg?v=1543513692",
        handle: "custom-jacks-sandal-medium-garnet-white",
      },
      {
        color: "Garnet",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_garnet-yellow_1024x1024.jpg?v=1543513697",
        handle: "custom-jacks-sandal-medium-garnet-yellow",
      },
      {
        color: "Gold",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20black_201000x872_1024x1024.jpg?v=1543513259",
        handle: "products/custom-jacks-sandal-medium-gold-black",
      },
      {
        color: "Gold",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_blush_1024x1024.jpg?v=1543513827",
        handle: "custom-jacks-sandal-medium-gold-blush",
      },
      {
        color: "Gold",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20bone_201000x872_1024x1024.jpg?v=1543513411",
        handle: "custom-jacks-sandal-medium-gold-bone",
      },
      {
        color: "Gold",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold-brightpink_1024x1024.jpg?v=1543514022",
        handle: "custom-jacks-sandal-medium-gold-bright-pink",
      },
      {
        color: "Gold",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20carribeanblue_201000x872_1024x1024.jpg?v=1543514005",
        handle: "custom-jacks-sandal-medium-gold-caribbean-blue",
      },
      {
        color: "Gold",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_dkorange_1024x1024.jpg?v=1543514018",
        handle: "custom-jacks-sandal-medium-gold-dark-orange",
      },
      {
        color: "Gold",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold-garnet_1024x1024.jpg?v=1543513832",
        handle: "custom-jacks-sandal-medium-gold-garnet",
      },
      {
        color: "Gold",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20gold_201000x872_1024x1024.jpg?v=1543513823",
        handle: "custom-jacks-sandal-medium-gold-gold",
      },
      {
        color: "Gold",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_green_1024x1024.jpg?v=1543514010",
        handle: "custom-jacks-sandal-medium-gold-green",
      },
      {
        color: "Gold",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_lightblue_1024x1024.jpg?v=1543513836",
        handle: "custom-jacks-sandal-medium-gold-light-blue",
      },
      {
        color: "Gold",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20navy_201000x872_1024x1024.jpg?v=1543514014",
        handle: "custom-jacks-sandal-medium-gold-midnight",
      },
      {
        color: "Gold",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20platinum_201000x872_1024x1024.jpg?v=1543514027",
        handle: "custom-jacks-sandal-medium-gold-platinum",
      },
      {
        color: "Gold",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_purple_1024x1024.jpg?v=1543514031",
        handle: "custom-jacks-sandal-medium-gold-purple",
      },
      {
        color: "Gold",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_red_1024x1024.jpg?v=1543514037",
        handle: "custom-jacks-sandal-medium-gold-red",
      },
      {
        color: "Gold",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20silver_201000x872_1024x1024.jpg?v=1543514042",
        handle: "custom-jacks-sandal-medium-gold-silver",
      },
      {
        color: "Gold",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/gold_20white_201000x872_1024x1024.jpg?v=1543514047",
        handle: "custom-jacks-sandal-medium-gold-white",
      },
      {
        color: "Gold",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_gold_yellow_1024x1024.jpg?v=1543514051",
        handle: "custom-jacks-sandal-medium-gold-yellow",
      },
      {
        color: "Green",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_black_1024x1024.jpg?v=1543514055",
        handle: "custom-jacks-sandal-medium-green-black",
      },
      {
        color: "Green",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_blush_1024x1024.jpg?v=1543513444",
        handle: "custom-jacks-sandal-medium-green-blush",
      },
      {
        color: "Green",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_bone_1024x1024.jpg?v=1543514240",
        handle: "custom-jacks-sandal-medium-green-bone",
      },
      {
        color: "Green",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green-brightpink_1024x1024.jpg?v=1543514073",
        handle: "custom-jacks-sandal-medium-green-bright-pink",
      },
      {
        color: "Green",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_caribblue_1024x1024.jpg?v=1543514060",
        handle: "custom-jacks-sandal-medium-green-caribbean-blue",
      },
      {
        color: "Green",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_dkorange_1024x1024.jpg?v=1543514069",
        handle: "custom-jacks-sandal-medium-green-dark-orange",
      },
      {
        color: "Green",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green-garnet_1024x1024.jpg?v=1543513448",
        handle: "custom-jacks-sandal-medium-green-garnet",
      },
      {
        color: "Green",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_gold_1024x1024.jpg?v=1543513468",
        handle: "custom-jacks-sandal-medium-green-gold",
      },
      {
        color: "Green",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_green_1024x1024.jpg?v=1543513432",
        handle: "custom-jacks-sandal-medium-green-green",
      },
      {
        color: "Green",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_lightblue_1024x1024.jpg?v=1543513453",
        handle: "custom-jacks-sandal-medium-green-light-blue",
      },
      {
        color: "Green",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_midnight_1024x1024.jpg?v=1543514064",
        handle: "custom-jacks-sandal-medium-green-midnight",
      },
      {
        color: "Green",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_platinum_1024x1024.jpg?v=1543514077",
        handle: "custom-jacks-sandal-medium-green-platinum",
      },
      {
        color: "Green",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_purple_1024x1024.jpg?v=1543513516",
        handle: "custom-jacks-sandal-medium-green-purple",
      },
      {
        color: "Green",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_red_1024x1024.jpg?v=1543514082",
        handle: "custom-jacks-sandal-medium-green-red",
      },
      {
        color: "Green",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_silver_1024x1024.jpg?v=1543513512",
        handle: "custom-jacks-sandal-medium-green-silver",
      },
      {
        color: "Green",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_white_1024x1024.jpg?v=1543513890",
        handle: "custom-jacks-sandal-medium-green-white",
      },
      {
        color: "Green",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_green_yellow_1024x1024.jpg?v=1543514087",
        handle: "custom-jacks-sandal-medium-green-yellow",
      },
      {
        color: "Light-Blue",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_black_1024x1024.jpg?v=1543513573",
        handle: "custom-jacks-sandal-medium-light-blue-black",
      },
      {
        color: "Light-Blue",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_blush_1024x1024.jpg?v=1543513570",
        handle: "custom-jacks-sandal-medium-light-blue-blush",
      },
      {
        color: "Light-Blue",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_bone_1024x1024.jpg?v=1543513559",
        handle: "custom-jacks-sandal-medium-light-blue-bone",
      },
      {
        color: "Light-Blue",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_brightpink_1024x1024.jpg?v=1543513589",
        handle: "custom-jacks-sandal-medium-light-blue-bright-pink",
      },
      {
        color: "Light-Blue",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_caribblue_1024x1024.jpg?v=1543513555",
        handle: "custom-jacks-sandal-medium-light-blue-caribbean-blue",
      },
      {
        color: "Light-Blue",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_dkorange_1024x1024.jpg?v=1543513585",
        handle: "custom-jacks-sandal-medium-light-blue-dark-orange",
      },
      {
        color: "Light-Blue",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_garnet_1024x1024.jpg?v=1543513566",
        handle: "custom-jacks-sandal-medium-light-blue-garnet",
      },
      {
        color: "Light-Blue",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_gold_1024x1024.jpg?v=1543513562",
        handle: "custom-jacks-sandal-medium-light-blue-gold",
      },
      {
        color: "Light-Blue",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_green_1024x1024.jpg?v=1543513581",
        handle: "custom-jacks-sandal-medium-light-blue-green",
      },
      {
        color: "Light-Blue",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_lightblue_1024x1024.jpg?v=1543513909",
        handle: "custom-jacks-sandal-medium-light-blue-light-blue",
      },
      {
        color: "Light-Blue",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_midnight_1024x1024.jpg?v=1543513577",
        handle: "custom-jacks-sandal-medium-light-blue-midnight",
      },
      {
        color: "Light-Blue",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_platinum_1024x1024.jpg?v=1543513601",
        handle: "custom-jacks-sandal-medium-light-blue-platinum",
      },
      {
        color: "Light-Blue",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_purple_1024x1024.jpg?v=1543513508",
        handle: "custom-jacks-sandal-medium-light-blue-purple",
      },
      {
        color: "Light-Blue",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_red_1024x1024.jpg?v=1543513593",
        handle: "custom-jacks-sandal-medium-light-blue-red",
      },
      {
        color: "Light-Blue",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_silver_1024x1024.jpg?v=1543513608",
        handle: "custom-jacks-sandal-medium-light-blue-silver",
      },
      {
        color: "Light-Blue",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_white_1024x1024.jpg?v=1543514237",
        handle: "custom-jacks-sandal-medium-light-blue-white",
      },
      {
        color: "Light-Blue",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_lightblue_yellow_1024x1024.jpg?v=1543513597",
        handle: "custom-jacks-sandal-medium-light-blue-yellow",
      },
      {
        color: "Midnight",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20black_201000x872_1024x1024.jpg?v=1543514095",
        handle: "custom-jacks-sandal-medium-midnight-black",
      },
      {
        color: "Midnight",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_blush_1024x1024.jpg?v=1543513477",
        handle: "custom-jacks-sandal-medium-midnight-blush",
      },
      {
        color: "Midnight",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20bone_201000x872_1024x1024.jpg?v=1543513349",
        handle: "custom-jacks-sandal-medium-midnight-bone",
      },
      {
        color: "Midnight",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_navy-brightpink_1024x1024.jpg?v=1543514104",
        handle: "custom-jacks-sandal-medium-midnight-bright-pink",
      },
      {
        color: "Midnight",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20carribeanblue_201000x872_1024x1024.jpg?v=1543514099",
        handle: "custom-jacks-sandal-medium-midnight-caribbean-blue",
      },
      {
        color: "Midnight",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_dkorange_1024x1024.jpg?v=1543513497",
        handle: "custom-jacks-sandal-medium-midnight-dark-orange",
      },
      {
        color: "Midnight",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight-garnet_1024x1024.jpg?v=1543513493",
        handle: "custom-jacks-sandal-medium-midnight-garnet",
      },
      {
        color: "Midnight",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20gold_201000x872_1024x1024.jpg?v=1543513527",
        handle: "custom-jacks-sandal-medium-midnight-gold",
      },
      {
        color: "Midnight",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_green_1024x1024.jpg?v=1543514091",
        handle: "custom-jacks-sandal-medium-midnight-green",
      },
      {
        color: "Midnight",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_lightblue_1024x1024.jpg?v=1543513489",
        handle: "custom-jacks-sandal-medium-midnight-light-blue",
      },
      {
        color: "Midnight",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20navy_201000x872_1024x1024.jpg?v=1543513520",
        handle: "custom-jacks-sandal-medium-midnight-midnight",
      },
      {
        color: "Midnight",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20platinum_201000x872_1024x1024.jpg?v=1543513524",
        handle: "custom-jacks-sandal-medium-midnight-platinum",
      },
      {
        color: "Midnight",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_purple_1024x1024.jpg?v=1543513123",
        handle: "custom-jacks-sandal-medium-midnight-purple",
      },
      {
        color: "Midnight",
        pattern: "Red",
        img: "//cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_red_486c14dc-feac-4b52-ba77-15451762fb4c_grande.jpg?v=1543514480",
        handle: "custom-jacks-sandal-wide-midnight-red",
      },
      {
        color: "Midnight",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20silver_201000x872_1024x1024.jpg?v=1543514116",
        handle: "custom-jacks-sandal-medium-midnight-silver",
      },
      {
        color: "Midnight",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/navy_20white_201000x872_1024x1024.jpg?v=1543513538",
        handle: "custom-jacks-sandal-medium-midnight-white",
      },
      {
        color: "Midnight",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_midnight_yellow_1024x1024.jpg?v=1543513500",
        handle: "custom-jacks-sandal-medium-midnight-yellow",
      },
      {
        color: "Platinum",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20black_201000x872_1024x1024.jpg?v=1543514177",
        handle: "custom-jacks-sandal-medium-platinum-black",
      },
      {
        color: "Platinum",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_blush_1024x1024.jpg?v=1543513185",
        handle: "custom-jacks-sandal-medium-platinum-blush",
      },
      {
        color: "Platinum",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20bone_201000x872_1024x1024.jpg?v=1543513422",
        handle: "custom-jacks-sandal-medium-platinum-bone",
      },
      {
        color: "Platinum",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum-brightpink_1024x1024.jpg?v=1543514204",
        handle: "custom-jacks-sandal-medium-platinum-bright-pink",
      },
      {
        color: "Platinum",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20carribeanblue_201000x872_1024x1024.jpg?v=1543514185",
        handle: "custom-jacks-sandal-medium-platinum-caribbean-blue",
      },
      {
        color: "Platinum",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_dkorange_1024x1024.jpg?v=1543514200",
        handle: "custom-jacks-sandal-medium-platinum-dark-orange",
      },
      {
        color: "Platinum",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum-garnet_1024x1024.jpg?v=1543513201",
        handle: "custom-jacks-sandal-medium-platinum-garnet",
      },
      {
        color: "Platinum",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20gold_201000x872_1024x1024.jpg?v=1543514181",
        handle: "custom-jacks-sandal-medium-platinum-gold",
      },
      {
        color: "Platinum",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_green_1024x1024.jpg?v=1543514191",
        handle: "custom-jacks-sandal-medium-platinum-green",
      },
      {
        color: "Platinum",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_lightblue_1024x1024.jpg?v=1543513210",
        handle: "custom-jacks-sandal-medium-platinum-light-blue",
      },
      {
        color: "Platinum",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20navy_201000x872_1024x1024.jpg?v=1543514195",
        handle: "custom-jacks-sandal-medium-platinum-midnight",
      },
      {
        color: "Platinum",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20platinum_201000x872_1024x1024.jpg?v=1543513180",
        handle: "custom-jacks-sandal-medium-platinum-platinum",
      },
      {
        color: "Platinum",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_purple_1024x1024.jpg?v=1543514208",
        handle: "custom-jacks-sandal-medium-platinum-purple",
      },
      {
        color: "Platinum",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_red_1024x1024.jpg?v=1543514212",
        handle: "custom-jacks-sandal-medium-platinum-red",
      },
      {
        color: "Platinum",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20silver_201000x872_1024x1024.jpg?v=1543514217",
        handle: "custom-jacks-sandal-medium-platinum-silver",
      },
      {
        color: "Platinum",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/platinum_20white_201000x872_1024x1024.jpg?v=1543513229",
        handle: "custom-jacks-sandal-medium-platinum-white",
      },
      {
        color: "Platinum",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_platinum_yellow_1024x1024.jpg?v=1543514221",
        handle: "custom-jacks-sandal-medium-platinum-yellow",
      },
      {
        color: "Purple",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_black_1024x1024.jpg?v=1543513150",
        handle: "custom-jacks-sandal-medium-purple-black",
      },
      {
        color: "Purple",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_blush_1024x1024.jpg?v=1543513613",
        handle: "custom-jacks-sandal-medium-purple-blush",
      },
      {
        color: "Purple",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_bone_1024x1024.jpg?v=1543512975",
        handle: "custom-jacks-sandal-medium-purple-bone",
      },
      {
        color: "Purple",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_brightpink_1024x1024.jpg?v=1543513224",
        handle: "custom-jacks-sandal-medium-purple-bright-pink",
      },
      {
        color: "Purple",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_caribblue_1024x1024.jpg?v=1543513158",
        handle: "custom-jacks-sandal-medium-purple-caribbean-blue",
      },
      {
        color: "Purple",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_dkorange_1024x1024.jpg?v=1543513189",
        handle: "custom-jacks-sandal-medium-purple-dark-orange",
      },
      {
        color: "Purple",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_garnet_1024x1024.jpg?v=1543513620",
        handle: "custom-jacks-sandal-medium-purple-garnet",
      },
      {
        color: "Purple",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_gold_1024x1024.jpg?v=1543512897",
        handle: "custom-jacks-sandal-medium-purple-gold",
      },
      {
        color: "Purple",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_green_1024x1024.jpg?v=1543513167",
        handle: "custom-jacks-sandal-medium-purple-green",
      },
      {
        color: "Purple",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_lightblue_1024x1024.jpg?v=1543513625",
        handle: "custom-jacks-sandal-medium-purple-light-blue",
      },
      {
        color: "Purple",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_midnight_1024x1024.jpg?v=1543513176",
        handle: "custom-jacks-sandal-medium-purple-midnight",
      },
      {
        color: "Purple",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_platinum_1024x1024.jpg?v=1543512887",
        handle: "custom-jacks-sandal-medium-purple-platinum",
      },
      {
        color: "Purple",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_purple_1024x1024.jpg?v=1543513146",
        handle: "custom-jacks-sandal-medium-purple-purple",
      },
      {
        color: "Purple",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_red_1024x1024.jpg?v=1543512892",
        handle: "custom-jacks-sandal-medium-purple-red",
      },
      {
        color: "Purple",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_silver_1024x1024.jpg?v=1543512908",
        handle: "custom-jacks-sandal-medium-purple-silver",
      },
      {
        color: "Purple",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_white_1024x1024.jpg?v=1543512913",
        handle: "custom-jacks-sandal-medium-purple-white",
      },
      {
        color: "Purple",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_purple_yellow_1024x1024.jpg?v=1543512903",
        handle: "custom-jacks-sandal-medium-purple-yellow",
      },
      {
        color: "Red",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_black_1024x1024.jpg?v=1543513062",
        handle: "custom-jacks-sandal-medium-red-black",
      },
      {
        color: "Red",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_blush_1024x1024.jpg?v=1543513702",
        handle: "custom-jacks-sandal-medium-red-blush",
      },
      {
        color: "Red",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_bone_1024x1024.jpg?v=1543512981",
        handle: "custom-jacks-sandal-medium-red-bone",
      },
      {
        color: "Red",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_caribblue_1024x1024.jpg?v=1543512922",
        handle: "custom-jacks-sandal-medium-red-caribbean-blue",
      },
      {
        color: "Red",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_dkorange_1024x1024.jpg?v=1543513294",
        handle: "custom-jacks-sandal-medium-red-dark-orange",
      },
      {
        color: "Red",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_gold_1024x1024.jpg?v=1543513075",
        handle: "custom-jacks-sandal-medium-red-gold",
      },
      {
        color: "Red",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_green_1024x1024.jpg?v=1543513285",
        handle: "custom-jacks-sandal-medium-red-green",
      },
      {
        color: "Red",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_lightblue_1024x1024.jpg?v=1543513707",
        handle: "custom-jacks-sandal-medium-red-light-blue",
      },
      {
        color: "Red",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_midnight_1024x1024.jpg?v=1543513712",
        handle: "custom-jacks-sandal-medium-red-midnight",
      },
      {
        color: "Red",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_platinum_1024x1024.jpg?v=1543513054",
        handle: "custom-jacks-sandal-medium-red-platinum",
      },
      {
        color: "Red",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_purple_1024x1024.jpg?v=1543512965",
        handle: "custom-jacks-sandal-medium-red-purple",
      },
      {
        color: "Red",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_red_1024x1024.jpg?v=1543513049",
        handle: "custom-jacks-sandal-medium-red-red",
      },
      {
        color: "Red",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_silver_1024x1024.jpg?v=1543512960",
        handle: "custom-jacks-sandal-medium-red-silver",
      },
      {
        color: "Red",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_white_1024x1024.jpg?v=1543513058",
        handle: "custom-jacks-sandal-medium-red-white",
      },
      {
        color: "Red",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_red_yellow_1024x1024.jpg?v=1543512970",
        handle: "custom-jacks-sandal-medium-red-yellow",
      },
      {
        color: "Silver",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20black_201000x872_1024x1024.jpg?v=1543513324",
        handle: "custom-jacks-sandal-medium-silver-black",
      },
      {
        color: "Silver",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_blush_1024x1024.jpg?v=1543513206",
        handle: "custom-jacks-sandal-medium-silver-blush",
      },
      {
        color: "Silver",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20bone_201000x872_1024x1024.jpg?v=1543513427",
        handle: "custom-jacks-sandal-medium-silver-bone",
      },
      {
        color: "Silver",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_brightpink_1024x1024.jpg?v=1543513306",
        handle: "custom-jacks-sandal-medium-silver-bright-pink",
      },
      {
        color: "Silver",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20carribeanblue_201000x872_1024x1024.jpg?v=1543513329",
        handle: "custom-jacks-sandal-medium-silver-caribbean-blue",
      },
      {
        color: "Silver",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_dkorange_1024x1024.jpg?v=1543513344",
        handle: "custom-jacks-sandal-medium-silver-dark-orange",
      },
      {
        color: "Silver",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver-garnet_1024x1024.jpg?v=1543513219",
        handle: "custom-jacks-sandal-medium-silver-garnet",
      },
      {
        color: "Silver",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20gold_201000x872_1024x1024.jpg?v=1543513334",
        handle: "custom-jacks-sandal-medium-silver-gold",
      },
      {
        color: "Silver",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/jacks_silver_green_1024x1024_3e532287-9426-4500-abdb-423b89523e85.jpg?3521",
        handle: "custom-jacks-sandal-medium-silver-green",
      },
      {
        color: "Silver",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_lightblue_1024x1024.jpg?v=1543513195",
        handle: "custom-jacks-sandal-medium-silver-light-blue",
      },
      {
        color: "Silver",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20navy_201000x872_1024x1024.jpg?v=1543513339",
        handle: "custom-jacks-sandal-medium-silver-midnight",
      },
      {
        color: "Silver",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20platinum_201000x872_1024x1024.jpg?v=1543513239",
        handle: "custom-jacks-sandal-medium-silver-platinum",
      },
      {
        color: "Silver",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_purple_1024x1024.jpg?v=1543513366",
        handle: "custom-jacks-sandal-medium-silver-purple",
      },
      {
        color: "Silver",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_red_1024x1024.jpg?v=1543513391",
        handle: "custom-jacks-sandal-medium-silver-red",
      },
      {
        color: "Silver",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20silver_201000x872_1024x1024.jpg?v=1543513215",
        handle: "custom-jacks-sandal-medium-silver-silver",
      },
      {
        color: "Silver",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/silver_20white_201000x872_1024x1024.jpg?v=1543513405",
        handle: "custom-jacks-sandal-medium-silver-white",
      },
      {
        color: "Silver",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_silver_yellow_1024x1024.jpg?v=1543513437",
        handle: "custom-jacks-sandal-medium-silver-yellow",
      },
      {
        color: "White",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20black_201000x872_1024x1024.jpg?v=1543512943",
        handle: "custom-jacks-sandal-medium-white-black",
      },
      {
        color: "White",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_blush_1024x1024.jpg?v=1543513268",
        handle: "custom-jacks-sandal-medium-white-blush",
      },
      {
        color: "White",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20bone_201000x872_1024x1024.jpg?v=1543512986",
        handle: "custom-jacks-sandal-medium-white-bone",
      },
      {
        color: "White",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_brightpink_1024x1024.jpg?v=1543513299",
        handle: "custom-jacks-sandal-medium-white-bright-pink",
      },
      {
        color: "White",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20carribeanblue_201000x872_1024x1024.jpg?v=1543513008",
        handle: "custom-jacks-sandal-medium-white-caribbean-blue",
      },
      {
        color: "White",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_dkorange_1024x1024.jpg?v=1543513457",
        handle: "custom-jacks-sandal-medium-white-dark-orange",
      },
      {
        color: "White",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_garnet_1024x1024.jpg?v=1543513272",
        handle: "custom-jacks-sandal-medium-white-garnet",
      },
      {
        color: "White",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20gold_201000x872_1024x1024.jpg?v=1543512933",
        handle: "custom-jacks-sandal-medium-white-gold",
      },
      {
        color: "White",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_green_1024x1024.jpg?v=1543513281",
        handle: "custom-jacks-sandal-medium-white-green",
      },
      {
        color: "White",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_lightblue_1024x1024.jpg?v=1543513276",
        handle: "custom-jacks-sandal-medium-white-light-blue",
      },
      {
        color: "White",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20navy_201000x872_1024x1024.jpg?v=1543513289",
        handle: "custom-jacks-sandal-medium-white-midnight",
      },
      {
        color: "White",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20platinum_201000x872_1024x1024.jpg?v=1543512938",
        handle: "custom-jacks-sandal-medium-white-platinum",
      },
      {
        color: "White",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_purple_1024x1024.jpg?v=1543513012",
        handle: "custom-jacks-sandal-medium-white-purple",
      },
      {
        color: "White",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_red_1024x1024.jpg?v=1543512955",
        handle: "custom-jacks-sandal-medium-white-red",
      },
      {
        color: "White",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20silver_201000x872_1024x1024.jpg?v=1543512927",
        handle: "custom-jacks-sandal-medium-white-silver",
      },
      {
        color: "White",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/white_20white_201000x872_1024x1024.jpg?v=1543512917",
        handle: "custom-jacks-sandal-medium-white-white",
      },
      {
        color: "White",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_white_yellow_1024x1024.jpg?v=1543512948",
        handle: "custom-jacks-sandal-medium-white-yellow",
      },
      {
        color: "Yellow",
        pattern: "Black",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_black_1024x1024.jpg?v=1543513017",
        handle: "custom-jacks-sandal-medium-yellow-black",
      },
      {
        color: "Yellow",
        pattern: "Blush",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_blush_1024x1024.jpg?v=1543513840",
        handle: "custom-jacks-sandal-medium-yellow-blush",
      },
      {
        color: "Yellow",
        pattern: "Bone",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_bone_1024x1024.jpg?v=1543512994",
        handle: "custom-jacks-sandal-medium-yellow-bone",
      },
      {
        color: "Yellow",
        pattern: "Bright-Pink",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_brightpink_1024x1024.jpg?v=1543513531",
        handle: "custom-jacks-sandal-medium-yellow-bright-pink",
      },
      {
        color: "Yellow",
        pattern: "Caribbean-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_caribblue_1024x1024.jpg?v=1543513021",
        handle: "custom-jacks-sandal-medium-yellow-caribbean-blue",
      },
      {
        color: "Yellow",
        pattern: "Dark-Orange",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_dkorange_1024x1024.jpg?v=1543513504",
        handle: "custom-jacks-sandal-medium-yellow-dark-orange",
      },
      {
        color: "Yellow",
        pattern: "Garnet",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_garnet_1024x1024.jpg?v=1543513845",
        handle: "custom-jacks-sandal-medium-yellow-garnet",
      },
      {
        color: "Yellow",
        pattern: "Gold",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_gold_1024x1024.jpg?v=1543513025",
        handle: "custom-jacks-sandal-medium-yellow-gold",
      },
      {
        color: "Yellow",
        pattern: "Green",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_green_1024x1024.jpg?v=1543513473",
        handle: "custom-jacks-sandal-medium-yellow-green",
      },
      {
        color: "Yellow",
        pattern: "Light-Blue",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_lightblue_1024x1024.jpg?v=1543513850",
        handle: "custom-jacks-sandal-medium-yellow-light-blue",
      },
      {
        color: "Yellow",
        pattern: "Midnight",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_midnight_1024x1024.jpg?v=1543513485",
        handle: "custom-jacks-sandal-medium-yellow-midnight",
      },
      {
        color: "Yellow",
        pattern: "Platinum",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_platinum_1024x1024.jpg?v=1543513029",
        handle: "custom-jacks-sandal-medium-yellow-platinum",
      },
      {
        color: "Yellow",
        pattern: "Purple",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_purple_1024x1024.jpg?v=1543513033",
        handle: "custom-jacks-sandal-medium-yellow-purple",
      },
      {
        color: "Yellow",
        pattern: "Red",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_red_1024x1024.jpg?v=1543513037",
        handle: "custom-jacks-sandal-medium-yellow-red",
      },
      {
        color: "Yellow",
        pattern: "Silver",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_silver_1024x1024.jpg?v=1543513045",
        handle: "custom-jacks-sandal-medium-yellow-silver",
      },
      {
        color: "Yellow",
        pattern: "White",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_white_1024x1024.jpg?v=1543513071",
        handle: "custom-jacks-sandal-medium-yellow-white",
      },
      {
        color: "Yellow",
        pattern: "Yellow",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/products/Jacks_yellow_yellow_1024x1024.jpg?v=1543513067",
        handle: "custom-jacks-sandal-medium-yellow-yellow",
      },
    ];

    //Default Variables
    var color;
    var stitch;
    var $step5 = $(".js-stepFive");
    var $forward = $(".js-forward");
    var $mobileSize = $(".js-sizeMobile");
    var $selectedExists = $(".js-forward").attr("data-first-option");
    var $selectedExists2 = $(".js-forward").data("first-option");
    var $selectedExistsTwo = $(".js-forward").attr("data-second-option");

    //Slider for color swatches
    $(".js-slides").slick({
      centerMode: true,
      centerPadding: "60px",
      arrows: false,
      slidesToShow: 5,
      swipeToSlide: true,
    });

    //Slider for stitch color swatches
    $(".js-slider").slick({
      centerMode: true,
      centerPadding: "60px",
      arrows: false,
      slidesToShow: 5,
      swipeToSlide: true,
    });

    //On the forward arrow key click
    $(document).on("click", ".js-forward", function () {
      let $stepPosition = $(this).closest(".js-stepContainer");
      let $step = $(this).attr("data-step");
      $selectedExists = $(".js-forward").attr("data-first-option");
      $selectedExistsTwo = $(".js-forward").attr("data-second-option");

      //If data-attribute is equal to step 1
      if ($step == "step3") {
        //Increment the step value to step 2
        $(this).attr("data-step", "step4");
        //Also change the data-attribute of the back button
        $stepPosition.find(".js-back").attr("data-step", "step4");
        //Remove the active class
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        //Add the active class to the stitch slider
        $(".js-stitchSlider").addClass("active");

        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile4").addClass("active");

        $(".js-back").addClass("show");
        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        } else {
          $forward.prop("disabled", true);
          $(".js-forward").attr("data-first-option", true);
        }
        if ($selectedExistsTwo == "true") {
        } else {
          $forward.prop("disabled", true);
        }
      } else if ($step == "step4") {
        $(this).attr("data-step", "step5");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-Size").addClass("active");
        $stepPosition.find(".js-back").attr("data-step", "step5");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile5").addClass("active");
        $forward.removeClass("show");
        if ($selectedExistsTwo == "true") {
          $forward.prop("disabled", false);
        } else {
          $forward.prop("disabled", true);
          $(".js-forward").attr("data-second-option", true);
        }
        $(".js-textContainerRight").addClass("expand");
      }
      $(".js-slider").slick("setPosition");
    });

    //Mobile Back
    $(".js-back").click(function () {
      let $stepPosition = $(this).closest(".js-stepContainer");
      let $step = $(this).attr("data-step");
      $selectedExists = $(".js-forward").attr("data-first-option");
      $selectedExistsTwo = $(".js-forward").attr("data-second-option");
      if ($step == "step4") {
        $(this).attr("data-step", "step3");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-colorSlider").addClass("active");
        $stepPosition.find(".js-forward").attr("data-step", "step3");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile3").addClass("active");
        $(".js-back").removeClass("show");
        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        }
      } else if ($step == "step5") {
        $(this).attr("data-step", "step4");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-stitchSlider").addClass("active");
        $stepPosition.find(".js-forward").attr("data-step", "step4");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile4").addClass("active");
        $forward.addClass("show");
        if ($selectedExistsTwo == "true") {
          $forward.prop("disabled", false);
        }
      }
      $(".js-slides").slick("setPosition");
      $(".js-slider").slick("setPosition");
    });

    //Clicking the start button on main image
    $(".js-start").click(function () {
      $(".js-stepOne .js-title").trigger("click");
      $(".js-mobile").addClass("active");
      $(".js-top").addClass("show");
    });

    //When clicking the numbers, open up the tab
    $(".js-title").click(function () {
      $(this).closest(".js-leftSide").find(".js-step").removeClass("active");
      $(".js-textContainerRight").removeClass("active");
      $(this).closest(".js-leftSide").addClass("active");
      $(".ProductCustom__right__step--1").removeClass("active");
      $(".ProductCustom__right__step--2").addClass("active");
      $(this).closest(".js-step").addClass("active");
      $(this).addClass("active");
    });

    //Open up step 2 tab, close step 1 tab
    $(".js-next").click(function () {
      $(this).closest(".js-step").removeClass("active");
      $(".js-stepFour").addClass("active");
    });

    $(".js-colorSwatch").click(function () {
      $(".js-forward").addClass("show");
      $(this)
        .closest(".ProductCustom__color--swatches")
        .find(".ProductCustom__swatch--item")
        .removeClass("show");
      $(this).closest(".ProductCustom__swatch--item").addClass("show");
      color = $(this).data("color");
      $(this).closest(".ProductCustom--options").find(".js-next").addClass("active");
      $(".js-optionColor").empty();
      $(this).closest(".ProductCustom__swatch--container").clone().appendTo(".js-optionColor");
      $forward.prop("disabled", false);
      changeImage();
      addSizeVariant();
    });

    $(".js-stitchSwatch").click(function () {
      $(this)
        .closest(".ProductCustom__stitch--swatches")
        .find(".ProductCustom__swatch--item")
        .removeClass("show");
      $(this).closest(".ProductCustom__swatch--item").addClass("show");
      $(this).closest(".ProductCustom--options").find(".ProductCustom__nexted").addClass("active");
      stitch = $(this).data("stitch");
      $(".js-optionStitch").empty();
      $(this).closest(".ProductCustom__swatch--container").clone().appendTo(".js-optionStitch");
      if ($selectedExistsTwo == "") {
        $forward.prop("disabled", false);
      }
      changeImage();
      addSizeVariant();
    });

    //Go Back
    $(".js-prev").click(function () {
      $(".js-stepFour").removeClass("active");
      $(".js-stepThree").addClass("active");
    });

    $(".js-prevFive").click(function () {
      $(".js-stepFive").removeClass("active");
      $(".js-stepFour").addClass("active");
    });

    //Open up step 3 tab, close step 2 tab
    $(".js-nextFour").click(function () {
      $(this).closest(".js-stepFour").removeClass("active");
      $step5.addClass("active");
    });

    $(".js-nextFive").click(function () {
      $(".js-optionSize .js-sizeContainer").empty();
      //$('.ProductCustom--left').removeClass('active');
      //$(this).closest('.js-stepFive').removeClass('active');
      $(".js-sizeContainer select").each(function () {
        var selectedValue = $(this).val();
        $(this).clone().val(selectedValue).appendTo(".js-optionSize .js-sizeContainer");
      });
      var spliced = $(".js-optionSize .js-sizeContainer select");
      for (var i = 0; i < spliced.length; i += 2) {
        spliced
          .slice(i, i + 2)
          .wrapAll('<div class="productSelect--custom--2 js-variantQuantity"></div>');
      }
      $(".ProductCustom__add").addClass("show");
      $step5.removeClass("active");
      $(".js-leftSide").removeClass("active");
      $(".js-textContainerRight").addClass("active");
    });

    //Add the products into the cart
    $(".js-add").click(function (i) {
      $(".js-sizeContainer2 .js-variantQuantity").each(function () {
        let variant = $(this).find(".js-variant").val();
        let quantity = $(this).find(".js-quantity").val();

        // document.querySelector("side-cart").addToCart(variant, quantity);
        CartJS.addItem(variant, quantity);
      });
    });

    //Mobile add button
    $(".js-addMobile").click(function () {
      $mobileSize.find(".js-variantQuantity").each(function () {
        let variant = $(this).find(".js-variant").val();
        let quantity = $(this).find("js-quantity").val();
        console.log(variant, quantity);
        CartJS.addItem(variant, quantity);
      });
    });
    $(".js-rightExpand").click(function () {
      $(this).closest(".js-textContainerRight").addClass("expand");
    });
    $(".js-close").click(function (e) {
      e.preventDefault();
      $(this).closest(".js-textContainerRight").removeClass("expand");
      $(".ProductMonogram__image-sandal").removeClass("slide-left");
      if (window.matchMedia("(max-width: 1149px)").matches) {
        $(".js-mobile").removeClass("active");
        $(".js-top").removeClass("show");
        $(".ProductMonogram--right").removeClass("active");
        $(".ProductMonogram__right__step--2").removeClass("active");
        $(".ProductMonogram__right__step--1").addClass("active");
        $(".js-leftSide").removeClass("active");
        $(".js-leftSide .js-step").removeClass("active");
        $(".js-leftSide .js-title").removeClass("active");
        $(".js-textContainerRight").removeClass("active");
      }
    });

    //Reset button for mobile
    $(".js-reset").click(function () {
      $(this).removeClass("show");
      $(".js-optionColor").empty();
      $(".js-optionStitch").empty();
      $(".js-stepMobile").each(function () {
        $(this).removeClass("active");
      });
      $(".js-stepMobile1").addClass("active");
      $(".js-valueMobile").each(function () {
        $(this).removeClass("active");
      });
      $(".js-colorSlider").addClass("active");
      $(".js-forward").attr("data-step", "step1");
      $(".js-forward").attr("data-first-option", "");
      $(".js-forward").attr("data-second-option", "");
      $(".js-back").attr("data-step", "step1");
      $(".js-textContainerRight").removeClass("expand");
    });
    //Loads Size Variants after selecting colors
    function changeImage() {
      _.find(variants, function (o) {
        if (o.color === color) {
          if (o.pattern === stitch) {
            var image = o.img;
            $(".ProductCustom__image-sandal img").attr("src", image);
          }
        }
      });
    }
    function addSizeVariant() {

      /* START JRU-326 1/2 (Monogram Shop Broken) */
      if (color === 'Magenta') {
        color = 'Fuchsia';
      }

      if (stitch === 'Magenta') {
        stitch = 'Fuchsia';
      }
      /* END JRU-326 1/2 (Monogram Shop Broken) */

      _.find(variants, function (o) {
        if (o.color === color) {
          if (o.pattern === stitch) {
            var handle = o.handle;
            $.ajax({
              type: "GET",
              url: "https://www.jackrogersusa.com/products/" + handle,
              beforeSend: function () {
                $mobileSize.addClass("loader");
                $(".ProductCustom__step--3 .ProductCustom__options").addClass("loader");
                $(".js-sizeContainer").empty();
                $(".js-sizeMobile").empty();
              },
              success: function (data) {
                var productForm = $(data).find(
                  '[data-section-type="product"] .productSelect--custom'
                );
                var productPrice = $(data).find("#ProductPrice").text();
                console.log(productForm, productPrice);
                $mobileSize.removeClass("loader");
                $mobileSize.append(productForm);
                $step5.find(".js-sizeContainer").append(productForm.clone());
                $(".price").text(productPrice);
                $(".ProductCustom__label").addClass("show");
                $(".js-nextFive").addClass("active");
                $(".ProductCustom__step--3 .ProductCustom__options").removeClass("loader");
                //script
                $(".SingleOptionSelector-1").change(function () {
                  var selectedVal = $(this).val();
                });
                // $('.js-nextFive').attr('disabled', true).removeClass('active');
                $(".js-sizeContainer .js-variant").on("change", function () {
                  console.log("changed");
                  $(".js-nextFive").attr("disabled", false).addClass("active");
                });
                $(".js-addMore").click(function () {
                  $step5.find(".ProductCustom__size--swatches").append(productForm.clone());
                  $(".js-sizeContainer .js-variant").each(function () {
                    // var nullVariant = $(this).val();
                    // if (nullVariant == null){
                    //    $('.js-nextFive').attr('disabled', true).removeClass('active');
                    // }
                  });

                  $(".js-sizeContainer .js-variant").on("change", function () {
                    console.log("changed");
                    $(".js-nextFive").attr("disabled", false).addClass("active");
                  });
                });
                $(".js-addMore--2").click(function () {
                  $(".js-sizeContainer2").append(productForm.clone());
                  $(".js-sizeContainer2 .js-variant").each(function () {
                    // var nullVariant2 = $(this).val();
                    // if (nullVariant2 == null){
                    //    $('.js-add button').attr('disabled', true).addClass('disabled');
                    // }
                  });
                  $(".js-sizeContainer2 .js-variant").on("change", function () {
                    console.log("changed");
                    $(".js-add button").attr("disabled", false).removeClass("disabled");
                  });
                });

                $(".js-sizeMobile .js-variant").each(function () {
                  var nullVariant2 = $(this).val();
                  if (nullVariant2 == null) {
                    $(".js-addMobile button").attr("disabled", true).addClass("disabled");
                  }
                });
                $(".js-sizeMobile .js-variant").on("change", function () {
                  console.log("changed");
                  $(".js-addMobile button").attr("disabled", false).removeClass("disabled");
                });

                $(".js-addMore--3").click(function () {
                  $mobileSize.append(productForm.clone());
                  $(".js-sizeMobile .js-variant").each(function () {
                    var nullVariant2 = $(this).val();
                    if (nullVariant2 == null) {
                      $(".js-addMobile button").attr("disabled", true).addClass("disabled");
                    }
                  });

                  $(".js-sizeMobile .js-variant").on("change", function () {
                    console.log("changed");
                    $(".js-addMobile button").attr("disabled", false).removeClass("disabled");
                  });
                });
              },
            });
          }
        }
      });
    }
  }

  function activeProduct() {
    $(document).ready(function () {
      $(".ProductForm__value--size").click(function () {
        $(this)
          .closest(".ProductForm__values")
          .find(".ProductForm__value--size")
          .removeClass("active");
        $(this).addClass("active");
        var selectedVal = $(this).val();
        var replaceVal = $(this).closest("form").find(".js-sizeLabel .ProductForm__size-label");
        $(replaceVal).text(selectedVal);
      });
    });
  }

  function productVariant() {
    $(".js-sizeVariantButton").on("change", function (e) {
      var selectedValue = $(this).val();
      var replaceVal = $(this).closest("form").find(".js-sizeLabel .ProductForm__size-label");
      $(replaceVal).text(selectedValue);
      $(replaceVal).removeClass("lowInv");

      $(this)
        .closest("form")
        .find("#productSelect option")
        .each(function () {
          var wantedValue = $(this).text().split(/[/]+/);
          if (wantedValue[0].trim() == selectedValue) {
            var newAttr = $(this).attr("value");
            console.log(newAttr);
            $(".js-productAdd").attr("data-cart-add", newAttr);
            // $('.js-productAdds-2').attr('data-cart-add', newAttr);
            console.log("newAttr", newAttr);
            $(".js-buyItNowButton").attr("data-cart-add", newAttr);

            console.log(variantsCount[newAttr]);
            if (Number(variantsCount[newAttr]) <= 5 && Number(variantsCount[newAttr]) > 0) {
              $(replaceVal).text("Only " + variantsCount[newAttr] + " left!");
              $(replaceVal).addClass("lowInv");
            }
          }
        });
    });

    $(".js-productAdd").click(function () {
      var quantitys = $(".quantity-adjust input").val();
      $(this).attr("data-cart-quantity", quantitys);
      console.log($(this).attr("data-cart-add"));
      $(document).on("cart.requestComplete", function (event, cart) {});
    });
    $(".js-productAdds-2").click(function (e) {
      // $('.js-buyItNowButton').click(function(e){
      e.preventDefault();

      var quantitys = $(".quantity-adjust input").val();
      $(this).attr("data-cart-quantity", quantitys);
      console.log($(this).attr("data-cart-add"));
      $(document).on("cart.requestComplete", function (event, cart) {});
    });

    $(".Product__thumbnail--slider").slick({
      dots: true,
      nextArrow: $(".Product__thumb-arrows .next"),
      prevArrow: $(".Product__thumb-arrows .prev"),
    });
  }

  function initialChecker() {
    //Initialize first, second and third letters

    //On key up
    $(".js-initialForm input").on("keydown", function (event) {
      var arr = [8, 9, 16, 17, 20, 35, 36, 37, 38, 39, 40, 45, 46];

      // Allow letters
      for (var i = 65; i <= 90; i++) {
        arr.push(i);
      }

      // Prevent default if not in array
      if (jQuery.inArray(event.which, arr) === -1) {
        event.preventDefault();
      }
    });
    $(".js-initialForm input").keyup(function () {
      //Loop through each input
      $(this)
        .closest(".js-initialForm")
        .find("input")
        .each(function () {
          //Get value of each input
          let $initial = $(this);
          let $initialLetter = $initial.val();
          let $firstClass = $initial.hasClass("js-first");
          let $secondClass = $initial.hasClass("js-second");
          let $thirdClass = $initial.hasClass("js-third");
          //if input is not blank
          if ($initialLetter != "") {
            //if this input hass either one of these classes
            if ($firstClass == true) {
              $firstLetter = $initialLetter.toLowerCase();
            } else if ($secondClass == true) {
              $secondLetter = $initialLetter.toLowerCase();
            } else if ($thirdClass == true) {
              $thirdLetter = $initialLetter.toLowerCase();
            }
          } else {
            if ($firstClass == true) {
              $firstLetter = "";
            } else if ($secondClass == true) {
              $secondLetter = "";
            } else if ($thirdClass == true) {
              $thirdLetter = "";
            }
          }
        });

      let $appendFirstCircle;
      let $appendSecondCircle;
      let $appendThirdCircle;

      if ($monogramStyle == "circle") {
        $appendFirstCircle = monogramCircle[0][$firstLetter];
        $appendSecondCircle = monogramCircle[1][$secondLetter];
        $appendThirdCircle = monogramCircle[2][$thirdLetter];
      } else if ($monogramStyle == "diamond") {
        $appendFirstCircle = monogramDiamond[0][$firstLetter];
        $appendSecondCircle = monogramDiamond[1][$secondLetter];
        $appendThirdCircle = monogramDiamond[2][$thirdLetter];
      }
      console.log($appendFirstCircle);
      if (
        $firstLetter != "" &&
        $secondLetter != "" &&
        $thirdLetter != "" &&
        stitchColor !== undefined
      ) {
        $(".js-letterContainer").empty();
        $(".js-letterContainer").append(
          $appendFirstCircle,
          $appendSecondCircle,
          $appendThirdCircle
        );
        $(".js-nextFour").removeAttr("disabled").addClass("active");
        $(".js-forward").removeAttr("disabled");
        $(".js-optionStitch").empty();
        $(this)
          .closest(".ProductMonogram__initial--container")
          .find(".js-monogramLabel")
          .clone()
          .appendTo(".js-optionStitch");
        $(".js-optionStitch").append(
          '<div class="ProductMonogram__text--container"><div class="ProductMonogram__text--details"><p class="ProductMonogram__text--details--top">' +
            $monogramStyle +
            " " +
            stitchColor +
            '</p</div><p class="ProductMonogram__text--details--bottom">' +
            $firstLetter +
            $secondLetter +
            $thirdLetter +
            "</p></div></div>"
        );
      } else {
        $(".js-nextFour").attr("disabled", true).removeClass("active");
        $(".js-forward").attr("disabled", true);
      }
    });
  }

  function monogramJack() {
    //This contains all the combination and handles
    var variants = [
      // Jacks Flat Sandal
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MIDNIGHT-MIDNIGHT_d2910d51-542e-4a64-96a4-8926bce68462.jpg?v=1604020973",
        handle: "151201jk03",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MIDNIGHT-MIDNIGHT_d2910d51-542e-4a64-96a4-8926bce68462.jpg?v=1604020973",
        handle: "151201jk04",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MIDNIGHT-MIDNIGHT_d2910d51-542e-4a64-96a4-8926bce68462.jpg?v=1604020973",
        handle: "151201jk03-1",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MIDNIGHT-MIDNIGHT_d2910d51-542e-4a64-96a4-8926bce68462.jpg?v=1604020973",
        handle: "151201jk04-1",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_6.jpg?v=1604047395",
        handle: "151201jk03-4",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_6.jpg?v=1604047395",
        handle: "151201jk04-4",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_6.jpg?v=1604047395",
        handle: "151201jk03-5",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_6.jpg?v=1604047395",
        handle: "151201jk04-5",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MODNIGHT-PLATINUM.jpg?v=1604047302",
        handle: "151201jk03-2",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MODNIGHT-PLATINUM.jpg?v=1604047302",
        handle: "151201jk04-2",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MODNIGHT-PLATINUM.jpg?v=1604047302",
        handle: "151201jk03-3",
      },
      {
        style: "Jacks Flat",
        color: "Midnight",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/MODNIGHT-PLATINUM.jpg?v=1604047302",
        handle: "151201jk04-3",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_2.jpg?v=1604047788",
        handle: "151201jk03-13",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_2.jpg?v=1604047788",
        handle: "151201jk04-14",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_2.jpg?v=1604047788",
        handle: "151201jk03-14",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_2.jpg?v=1604047788",
        handle: "151201jk04-13",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-WHITE.jpg?v=1604048274",
        handle: "151201jk03-17",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-WHITE.jpg?v=1604048274",
        handle: "151201jk04-17",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-WHITE.jpg?v=1604048274",
        handle: "151201jk03-18",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-WHITE.jpg?v=1604048274",
        handle: "151201jk04-18",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-PLATINUM.jpg?v=1604047875",
        handle: "151201jk03-15",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-PLATINUM.jpg?v=1604047875",
        handle: "151201jk04-15",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-PLATINUM.jpg?v=1604047875",
        handle: "151201jk03-16",
      },
      {
        style: "Jacks Flat",
        color: "White",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/WHITE-PLATINUM.jpg?v=1604047875",
        handle: "151201jk04-16",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_7.jpg?v=1604047502",
        handle: "151201jk03-6",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_7.jpg?v=1604047502",
        handle: "151201jk04-6",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_7.jpg?v=1604047502",
        handle: "151201jk03-7",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_7.jpg?v=1604047502",
        handle: "151201jk04-7",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_10_be3e5078-5433-470b-ae6b-b7fee140c83f.jpg?v=1604047714",
        handle: "151201jk03-11",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_10_be3e5078-5433-470b-ae6b-b7fee140c83f.jpg?v=1604047714",
        handle: "151201jk04-10",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_10_be3e5078-5433-470b-ae6b-b7fee140c83f.jpg?v=1604047714 ",
        handle: "151201jk03-10",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/1024x1024_10_be3e5078-5433-470b-ae6b-b7fee140c83f.jpg?v=1604047714",
        handle: "151201jk04-11",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/PLATINUM-PLATINUM.jpg?v=1604047636",
        handle: "151201jk03-8",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/PLATINUM-PLATINUM.jpg?v=1604047636",
        handle: "151201jk04-8",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/PLATINUM-PLATINUM.jpg?v=1604047636",
        handle: "151201jk03-9",
      },
      {
        style: "Jacks Flat",
        color: "Platinum",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/PLATINUM-PLATINUM.jpg?v=1604047636",
        handle: "151201jk04-9",
      },

      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-MIDNIGHT.jpg?v=1681856664",
        handle: "151201jk03-19",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Midnight",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-MIDNIGHT.jpg?v=1681856664",
        handle: "151201jk04-19",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-MIDNIGHT.jpg?v=1681856664",
        handle: "151201jk03-20",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Midnight",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-MIDNIGHT.jpg?v=1681856664",
        handle: "151201jk04-20",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-WHITE.jpg?v=1681856664",
        handle: "151201jk03-21",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "White",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-WHITE.jpg?v=1681856664",
        handle: "151201jk04-21",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-WHITE.jpg?v=1681856664",
        handle: "151201jk03-22",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-WHITE.jpg?v=1681856664",
        handle: "151201jk04-22",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-PLATINUM.jpg?v=1681856664",
        handle: "151201jk03-23",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Platinum",
        stitchColor: "Midnight",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-PLATINUM.jpg?v=1681856664",
        handle: "151201jk04-23",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-PLATINUM.jpg?v=1681856664",
        handle: "151201jk03-24",
      },
      {
        style: "Jacks Flat",
        color: "Fuchsia",
        pattern: "Platinum",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/FUCHSIA-PLATINUM.jpg?v=1681856664",
        handle: "151201jk04-24",
      },

      {
        style: "Jacks Flat",
        color: "Black",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/BLACK-WHITE.jpg?v=1628198322",
        handle: "151201jk03-25",
      },
      {
        style: "Jacks Flat",
        color: "Black",
        pattern: "White",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/BLACK-WHITE.jpg?v=1628198322",
        handle: "151201jk04-25",
      },
      {
        style: "Jacks Flat",
        color: "Black",
        pattern: "Black",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/BLACK-BLACK.jpg?v=1628198322",
        handle: "151201jk03-26",
      },
      {
        style: "Jacks Flat",
        color: "Black",
        pattern: "Black",
        stitchColor: "White",
        stitchStyle: "diamond",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/BLACK-BLACK.jpg?v=1628198322",
        handle: "151201jk04-26",
      },

      {
        style: "Loafer",
        color: "n/a",
        pattern: "n/a",
        stitchColor: "Midnight",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/JacksLoafer.jpg?v=1628460785",
        handle: "151201jk07-1",
      },
      {
        style: "Loafer",
        color: "n/a",
        pattern: "n/a",
        stitchColor: "White",
        stitchStyle: "circle",
        img: "https://cdn.shopify.com/s/files/1/0035/0306/3153/files/JacksLoafer.jpg?v=1628460785",
        handle: "151201jk07-2",
      },
    ];

    //Default Variables
    var color;
    var style;
    var whipstitchColor;
    var stitch;
    var counter = 0;
    var $step5 = $(".js-stepFive");
    var $forward = $(".js-forward");
    var $mobileSize = $(".js-sizeMobile");
    var $selectedExists = $(".js-forward").attr("data-first-option");
    var $selectedExists2 = $(".js-forward").data("first-option");
    var $selectedExistsTwo = $(".js-forward").attr("data-second-option");

    // variable used for showing/hiding step 3 elements
    var currentOption;

    //Slider for color swatches
    $(".js-slides").slick({
      centerMode: true,
      centerPadding: "60px",
      arrows: false,
      slidesToShow: 5,
      swipeToSlide: true,
    });

    //Slider for stitch color swatches
    $(".js-slider").slick({
      centerMode: true,
      centerPadding: "60px",
      arrows: false,
      slidesToShow: 5,
      swipeToSlide: true,
    });

    $(".js-slideA").slick({
      centerMode: true,
      centerPadding: "60px",
      arrows: false,
      slidesToShow: 5,
      swipeToSlide: true,
    });

    //On the forward arrow key click
    $(document).on("click", ".js-forward", function () {
      let $stepPosition = $(this).closest(".js-stepContainer");
      let $step = $(this).attr("data-step");
      $selectedExists = $(".js-forward").attr("data-first-option");
      $selectedExistsTwo = $(".js-forward").attr("data-second-option");

      if ($step == "step1") {
        if (style != "Loafer") {
          $(this).attr("data-step", "step2");
          $stepPosition.find(".js-back").attr("data-step", "step2");
          $(this).closest(".js-mobile").find(".js-styleSelect").removeClass("active");
          $(".js-colorSlider").addClass("active");

          $stepPosition.find(".js-stepMobile").removeClass("active");
          $stepPosition.find(".js-stepMobile2").addClass("active");
          $(".js-back").addClass("show");
          $(".js-optionDiamond").show();

          $(".js-valueMobile .ProductMonogram__swatch--color--container").each(function () {
            $(this).removeClass("show");
            let productStyle = $(this).data("style"); // Product style. e.g Jacks Flat, Jacks Comfort, Loafer

            if (style == productStyle) {
              $(this).addClass("show");
            }
          });
        } else {
          $(this).attr("data-step", "step4");
          $stepPosition.find(".js-back").attr("data-step", "step2");
          $(this).closest(".js-mobile").find(".js-styleSelect").removeClass("active");
          $(".js-stitchSlider").addClass("active");

          $stepPosition.find(".js-stepMobile").removeClass("active");
          $stepPosition.find(".js-stepMobile4").addClass("active");
          $(".js-back").addClass("show");
          $(".js-optionDiamond").hide();
        }

        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        } else {
          $forward.prop("disabled", true);
          $(".js-forward").attr("data-first-option", true);
        }
        if ($selectedExistsTwo == "true") {
        } else {
          $forward.prop("disabled", true);
        }
      } else if ($step == "step2") {
        $(this).attr("data-step", "step3");
        $stepPosition.find(".js-back").attr("data-step", "step3");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");

        $(".js-whipstitchSelect").addClass("active");

        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile3").addClass("active");
        $(".js-back").addClass("show");

        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        } else {
          $forward.prop("disabled", true);
          $(".js-forward").attr("data-first-option", true);
        }
        if ($selectedExistsTwo == "true") {
        } else {
          $forward.prop("disabled", true);
        }
      }
      //If data-attribute is equal to step 1
      else if ($step == "step3") {
        //Increment the step value to step 2
        $(this).attr("data-step", "step4");
        //Also change the data-attribute of the back button
        $stepPosition.find(".js-back").attr("data-step", "step4");
        //Remove the active class
        $(this).closest(".js-mobile").find(".js-whipstitchSelect").removeClass("active");
        //Add the active class to the stitch slider
        $(".js-stitchSlider").addClass("active");

        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile4").addClass("active");

        $(".js-back").addClass("show");
        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        } else {
          $forward.prop("disabled", true);
          $(".js-forward").attr("data-first-option", true);
        }
        if ($selectedExistsTwo == "true") {
        } else {
          $forward.prop("disabled", true);
        }
        counter += 1;
      } else if ($step == "step4") {
        $(this).attr("data-step", "step5");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-Size").addClass("active");
        $stepPosition.find(".js-back").attr("data-step", "step5");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile5").addClass("active");
        $forward.removeClass("show");
        if ($selectedExistsTwo == "true") {
          $forward.prop("disabled", false);
        } else {
          $forward.prop("disabled", true);
          $(".js-forward").attr("data-second-option", true);
        }
        $(".js-textContainerRight").addClass("expand");
        $(".ProductMonogram__image-sandal").addClass("slide-left");
        addSizeVariant();
      }
      $(".js-slides").slick("setPosition");
      $(".js-slider").slick("setPosition");
      $(".js-slideA").slick("setPosition");
    });

    //Mobile Back
    $(".js-back").click(function () {
      let $stepPosition = $(this).closest(".js-stepContainer");
      let $step = $(this).attr("data-step");
      $selectedExists = $(".js-forward").attr("data-first-option");
      $selectedExistsTwo = $(".js-forward").attr("data-second-option");

      if ($step == "step2") {
        $(this).attr("data-step", "step1");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-styleSelect").addClass("active");
        $stepPosition.find(".js-forward").attr("data-step", "step1");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile1").addClass("active");
        $(".js-back").removeClass("show");
        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        }
      } else if ($step == "step3") {
        $(this).attr("data-step", "step2");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-colorSlider").addClass("active");
        $stepPosition.find(".js-forward").attr("data-step", "step2");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile2").addClass("active");
        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        }
      } else if ($step == "step4") {
        $(this).attr("data-step", "step3");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-whipstitchSelect").addClass("active");
        $stepPosition.find(".js-forward").attr("data-step", "step3");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile3").addClass("active");
        if ($selectedExists == "true") {
          $forward.prop("disabled", false);
        }
      } else if ($step == "step5") {
        $(this).attr("data-step", "step4");
        $(this).closest(".js-mobile").find(".js-valueMobile").removeClass("active");
        $(".js-stitchSlider").addClass("active");
        $stepPosition.find(".js-forward").attr("data-step", "step4");
        $stepPosition.find(".js-stepMobile").removeClass("active");
        $stepPosition.find(".js-stepMobile4").addClass("active");
        $forward.addClass("show");
        if ($selectedExistsTwo == "true") {
          $forward.prop("disabled", false);
        }
      }
      $(".js-slides").slick("setPosition");
      $(".js-slider").slick("setPosition");
      $(".js-slideA").slick("setPosition");
    });

    //Clicking the start button on main image
    $(".js-start").click(function () {
      $(".js-stepOne .js-title").trigger("click");
      $(".js-mobile").addClass("active");
      $(".js-top").addClass("show");
      $(".ProductMonogram--right").addClass("active");
    });

    //When clicking the numbers, open up the tab
    $(".js-title").click(function () {
      $(this).closest(".js-leftSide").find(".js-step").removeClass("active");
      $(".js-textContainerRight").removeClass("active");
      $(this).closest(".js-leftSide").addClass("active");
      $(".ProductMonogram__right__step--1").removeClass("active");
      $(".ProductMonogram__right__step--2").addClass("active");
      $(this).closest(".js-step").addClass("active");
      $(this).addClass("active");
    });

    //Open up step 2 tab, close step 1 tab
    $(".js-next").click(function () {
      $(this).closest(".js-step").removeClass("active");
      $(".js-stepFour").addClass("active");
    });

    $(".js-styleLabel").click(function () {
      $(this)
        .closest(".js-styleSelect")
        .find(".ProductMonogram__image--block")
        .removeClass("active");
      $(this)
        .closest(".js-monogramStyle")
        .find(".ProductMonogram__image--block")
        .removeClass("active");
      $(this).find(".ProductMonogram__image--block").addClass("active");

      style = $(this).data("style");
      $(".js-optionStyle").empty();
      $(".js-nextOne").attr("disabled", false);
      $(".ProductMonogram__next--0").addClass("active");

      if (style == "Jacks Flat") {
        currentOption = ".option_for_flat";
        $(".option_for_flat").show();
        $(".ProductMonogram__step--2").removeClass("disabled");
        $(".ProductMonogram__step--3").removeClass("disabled");

        // For monogram position change
        $(".js-letterContainer").removeClass("letters-for-comfort");
        $(".js-letterContainer").removeClass("letters-for-loafer");
        $(".js-letterContainer").addClass("letters-for-flat");

        // Show Whipstitch and Upper color blocks on the right side
        $(".ProductMonogram__text--right .js-optionWhipstitchTitle").show();
        $(".ProductMonogram__text--right .js-optionWhipstitch").show();
        $(".ProductMonogram__text--right .js-optionColorTitle").show();
        $(".ProductMonogram__text--right .js-optionColor").show();

        $(".ProductMonogram--right .js-rightExpand h1").text("NEW MONOGRAM SANDAL");
      } else if (style == "Loafer") {
        $(".ProductMonogram__step--2").addClass("disabled");
        $(".ProductMonogram__step--3").addClass("disabled");

        // For monogram position change
        $(".js-letterContainer").removeClass("letters-forcomfort");
        $(".js-letterContainer").removeClass("letters-for-flat");
        $(".js-letterContainer").addClass("letters-for-loafer");

        // Hide Whipstitch and Upper color blocks on the right side
        $(".ProductMonogram__text--right .js-optionWhipstitchTitle").hide();
        $(".ProductMonogram__text--right .js-optionWhipstitch").hide();
        $(".ProductMonogram__text--right .js-optionColorTitle").hide();
        $(".ProductMonogram__text--right .js-optionColor").hide();

        $(".ProductMonogram--right .js-rightExpand h1").text("Monogram Slipper");
      }

      if (style != "Loafer") {
        $(
          ".ProductMonogram__color--options .ProductMonogram__option--swatches .ProductMonogram__swatch--container"
        ).each(function () {
          if ($(this).attr("data-style") == style) {
            $(this).addClass("show");
          } else {
            $(this).removeClass("show");
          }
        });
      }

      let imageSrc = $(this).find("img").attr("src");

      $(".js-mainImage").attr("src", imageSrc);
      $(this).clone().appendTo(".js-optionStyle");
      $(".js-forward").attr("disabled", false);
    });

    $(".js-whipstitchLabel").click(function () {
      $(this)
        .closest(".js-whipstitchSelect")
        .find(".ProductMonogram__image--block")
        .removeClass("active");
      $(this)
        .closest(".js-monogramWipstitch")
        .find(".ProductMonogram__image--block")
        .removeClass("active");
      $(this).find(".ProductMonogram__image--block").addClass("active");
      whipstitchColor = $(this).data("style");
      $(".js-optionWhipstitch").empty();
      $(".js-nextThree").attr("disabled", false);
      $(".ProductMonogram__next--3 .js-nextThree").addClass("active");

      $(this).clone().appendTo(".js-optionWhipstitch");
      $(".js-forward").attr("disabled", false);
      changeImages();
      // addSizeVariant();

      // $('.js-valueMobile .ProductMonogram__swatch--color--container').each(function(){
      //   $(this).removeClass('show');
      //   let styleValue = $(this).data('tag'); // Whipstitch color
      //   let productStyle = $(this).data('style'); // Product style. e.g Jacks Flat, Jacks Comfort, Loafer

      //   if (whipstitchColor == styleValue && style == productStyle){
      //     $(this).addClass('show');
      //   }
      // });
    });

    $(".js-nextOne").click(function () {
      $(".js-stepOne").removeClass("active");

      if (style != "Loafer") {
        $(".js-stepTwo").addClass("active");
        $(".ProductMonogram__diamond--option").show();
      } else {
        $(".js-stepFour").addClass("active");
        $(".ProductMonogram__diamond--option").hide();
      }
    });

    $(".js-nextTwo").click(function () {
      // $('.ProductMonogram__color--swatches .ProductMonogram__swatch--color--container').each(function(){
      //   $(this).removeClass('show');
      //   let styleValue = $(this).data('tag'); // Whipstitch Color
      //   let productStyle = $(this).data('style'); // Product style. e.g Jacks Flat, Jacks Comfort, Loafer

      //   if (whipstitchColor == styleValue && style == productStyle){
      //     $(this).addClass('show');
      //   }
      // });
      $(".js-stepTwo").removeClass("active");
      $(".js-stepThree").addClass("active");
      if ($(".js-whipstitchLabel .ProductMonogram__image--block.active").length) {
        whipstitchColor = $(".js-whipstitchLabel .ProductMonogram__image--block.active")
          .parent()
          .attr("data-style");
        changeImages();
      }
    });

    $(".js-stepThree").click(function () {
      // $('.ProductMonogram__color--swatches .ProductMonogram__swatch--color--container').each(function(){
      //   $(this).removeClass('show');
      //   let styleValue = $(this).data('tag');
      //   let productStyle = $(this).data('style'); // Product style. e.g Jacks Flat, Jacks Comfort, Loafer

      //   if (whipstitchColor == styleValue && style == productStyle){
      //     $(this).addClass('show');
      //   }
      // });
      if ($(".js-whipstitchLabel .ProductMonogram__image--block.active").length) {
        whipstitchColor = $(".js-whipstitchLabel .ProductMonogram__image--block.active")
          .parent()
          .attr("data-style");
        changeImages();
      }
    });

    //On Swatch Click, change image
    $(".js-colorSwatch").click(function () {
      $(".js-forward").addClass("show");
      $(".js-nextTwo").attr("disabled", false).addClass("active");
      $(this)
        .closest(".ProductMonogram__color--swatches")
        .find(".ProductMonogram__swatch--item")
        .removeClass("show");
      $(this).closest(".ProductMonogram__swatch--item").addClass("show");
      color = $(this).data("color");
      tags = $(this).closest(".ProductMonogram__swatch--container").data("tags").split(",");

      if (color == "Black") {
        // disable Midnight monogram for Black upper-colored Sandals
        $(
          '.ProductMonogram__stitch-color .ProductMonogram__swatch--container[data-tag="Midnight"]'
        ).hide();
        $(
          '.ProductMonogram__stitch-color .ProductMonogram__swatch--container:not([data-tag="Midnight"])'
        ).show();
      } else {
        $(
          '.ProductMonogram__stitch-color .ProductMonogram__swatch--container[data-tag="Midnight"]'
        ).show();
      }

      $(".js-monogramWipstitch .js-whipstitchLabel").each(function () {
        if ($(this).data("type") == style && tags.includes($(this).data("style"))) {
          $(this).parent().show();
        } else {
          $(this).parent().hide();
        }
      });
      $(".js-whipstitchSelect .js-whipstitchLabel").each(function () {
        if ($(this).data("type") == style && tags.includes($(this).data("style"))) {
          $(this).css("display", "flex");
        } else {
          $(this).hide();
        }
      });

      $(this).closest(".ProductMonogram--options").find(".js-next").addClass("active");
      $(".js-optionColor").empty();
      $(this).closest(".ProductMonogram__swatch--container").clone().appendTo(".js-optionColor");
      $forward.prop("disabled", false);
      // changeImages();
      if (counter >= 1) {
        addSizeVariant();
      }

      console.log("style color whipstitch", style, color, whipstitchColor);
      if (style && color && whipstitchColor) {
        changeImages();
      } else {
        var tempStitchColor = currentOption
          ? $(`${currentOption} .js-whipstitchLabel`)[0].dataset.style
          : null;
        if (tempStitchColor) changeImages(tempStitchColor);
      }
    });

    $(".js-monogramLabel").click(function () {
      counter += 1;
      $(this).closest(".js-monogramOptions").find(".js-monogramContainer").removeClass("active");
      $(this).closest(".js-monogramContainer").addClass("active");
      $(".js-first").val("");
      $(".js-second").val("");
      $(".js-third").val("");
      $monogramStyle = $(this).closest(".js-monogramContainer").data("style");

      $(".js-optionStitch").empty();

      console.log($(this).clone());
      $(this).clone().appendTo(".js-optionStitch");

      addSizeVariant();
    });

    $(".js-stitchColor").click(function () {
      stitchColor = $(this).data("color");
      $(this)
        .closest(".ProductMonogram__option--swatches")
        .find(".ProductMonogram__swatch--item")
        .removeClass("show");
      $(this).closest(".ProductMonogram__swatch--item").addClass("show");
      if (stitchColor == "Midnight") {
        $(".js-letterContainer").addClass("ProductMonogram--midnight");
      } else {
        $(".js-letterContainer").removeClass("ProductMonogram--midnight");
      }

      $(".js-optionStitchColor").text(stitchColor);
      console.log($firstLetter, $secondLetter, $thirdLetter, stitchColor);
      if (
        $firstLetter != undefined &&
        $secondLetter != undefined &&
        $thirdLetter != undefined &&
        stitchColor !== undefined
      ) {
        $(".js-nextFour").removeAttr("disabled").addClass("active");
        $(".js-forward").removeAttr("disabled");
        addSizeVariant();
      }
    });

    $(".js-stitchSwatch").click(function () {
      $(this)
        .closest(".ProductMonogram__stitch--swatches")
        .find(".ProductMonogram__swatch--item")
        .removeClass("show");
      $(this).closest(".ProductMonogram__swatch--item").addClass("show");
      $(this)
        .closest(".ProductMonogram--options")
        .find(".ProductMonogram__nexted")
        .addClass("active");
      stitch = $(this).data("stitch");
      $(".js-optionStitch").empty();
      $(this).closest(".ProductMonogram__swatch--container").clone().appendTo(".js-optionStitch");
      if ($selectedExistsTwo == "") {
        $forward.prop("disabled", false);
      }
      changeImage();
      addSizeVariant();
    });

    $(".js-stepTwo .js-title").on("click", function () {
      $(".js-letterContainer").empty();
      $(".js-initialForm input").each(function () {
        $(this).val("");
      });
      console.log(color, style, whipstitchColor);
      if (style != "Loafer") {
        $(
          ".ProductMonogram__color--options .ProductMonogram__option--swatches .ProductMonogram__swatch--container"
        ).each(function () {
          if ($(this).attr("data-style") == style) {
            $(this).addClass("show");
          } else {
            $(this).removeClass("show");
          }
        });
      }
    });

    $(".js-prevTwo").click(function () {
      $(".js-letterContainer").empty();
      $(".js-stepTwo").removeClass("active");
      $(".js-stepOne").addClass("active");
    });

    $(".js-prevThree").click(function () {
      $(".js-letterContainer").empty();
      $(".js-stepThree").removeClass("active");
      $(".js-stepTwo").addClass("active");
    });

    //Go Back
    $(".js-prevFour").click(function () {
      if (style != "Loafer") {
        $(".js-stepFour").removeClass("active");
        $(".js-stepThree").addClass("active");
      } else {
        $(".js-stepFour").removeClass("active");
        $(".js-stepOne").addClass("active");
      }
    });

    $(".js-prevFive").click(function () {
      $(".js-stepFive").removeClass("active");
      $(".js-stepFour").addClass("active");
    });

    //Open up step 3 tab, close step 2 tab
    $(".js-nextFour").click(function () {
      $(this).closest(".js-stepFour").removeClass("active");
      $step5.addClass("active");

      if (style == "Loafer") {
        whipstitchColor = "n/a";
        color = "n/a";
        addSizeVariant();
      }
    });

    $(".js-nextThree").click(function () {
      $(".js-stepThree").removeClass("active");
      $(".js-stepFour").addClass("active");
    });

    $(".js-nextFive").click(function () {
      $(".js-optionSize .js-sizeContainer").empty();
      //$('.ProductMonogram--left').removeClass('active');
      //$(this).closest('.js-stepFive').removeClass('active');
      $(".js-sizeContainer select").each(function () {
        var selectedValue = $(this).val();
        $(this).clone().val(selectedValue).appendTo(".js-optionSize .js-sizeContainer");
      });
      var spliced = $(".js-optionSize .js-sizeContainer select");
      for (var i = 0; i < spliced.length; i += 2) {
        spliced
          .slice(i, i + 2)
          .wrapAll('<div class="productSelect--custom--2 js-variantQuantity"></div>');
      }
      $(".ProductMonogram__add").addClass("show");
      $step5.removeClass("active");
      $(".js-leftSide").removeClass("active");
      $(".js-textContainerRight").addClass("active");
    });

    // Function to handle adding items to the cart
    function addItemsToCart(containerSelector) {
      let fetchPromises = [];

      $(containerSelector)
        .find(".js-variantQuantity")
        .each(function () {
          let variant = $(this).find(".js-variant").val();
          let quantity = $(this).find(".js-quantity").val();
          let lineItems = {
            "1.First Letter": $firstLetter,
            "2.Second Letter": $secondLetter,
            "3.Third Letter": $thirdLetter,
          };

          console.log(variant, quantity, lineItems);

          let formData = {
            items: [
              {
                id: variant,
                quantity: quantity,
                properties: lineItems,
              },
            ],
          };

          // Push each fetch call into the fetchPromises array
          fetchPromises.push(
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .catch((error) => console.error("Error:", error))
          );
        });

      return Promise.all(fetchPromises);
    }

    // Function to refresh and open the cart drawer with a delay
    function refreshAndOpenCartDrawer(delay = 500) {
      document.dispatchEvent(
        new CustomEvent("dispatch:cart-drawer:refresh", {
          bubbles: true,
        })
      );

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open"));
      }, delay);
    }

    // Add products to the cart (desktop)
    $(".js-add").click(function () {
      addItemsToCart(".js-sizeContainer2").then(() => {
        refreshAndOpenCartDrawer();
      });
    });

    // Add products to the cart (mobile)
    $(".js-addMobile").click(function () {
      addItemsToCart($mobileSize).then(() => {
        refreshAndOpenCartDrawer();
      });
    });

    $(".js-rightExpand").click(function () {
      $(this).closest(".js-textContainerRight").addClass("expand");
      $(".ProductMonogram__image-sandal").addClass("slide-left");
    });
    $(".js-close").click(function (e) {
      e.preventDefault();
      $(this).closest(".js-textContainerRight").removeClass("expand");
      $(".ProductMonogram__image-sandal").removeClass("slide-left");
      if (window.matchMedia("(max-width: 1149px)").matches) {
        $(".js-mobile").removeClass("active");
        $(".js-top").removeClass("show");
        $(".ProductMonogram--right").removeClass("active");
        $(".ProductMonogram__right__step--2").removeClass("active");
        $(".ProductMonogram__right__step--1").addClass("active");
        $(".js-leftSide").removeClass("active");
        $(".js-leftSide .js-step").removeClass("active");
        $(".js-leftSide .js-title").removeClass("active");
        $(".js-textContainerRight").removeClass("active");
      }
    });

    //Reset button for mobile
    $(".js-reset").click(function () {
      $(this).removeClass("show");
      $(".js-optionWhipstitch").empty();
      $(".js-optionColor").empty();
      $(".js-optionStitch").empty();
      $(".js-stepMobile").each(function () {
        $(this).removeClass("active");
      });
      $(".js-stepMobile1").addClass("active");
      $(".js-valueMobile").each(function () {
        $(this).removeClass("active");
      });
      $(".js-styleSelect").addClass("active");
      $(".js-forward").attr("data-step", "step1");
      $(".js-forward").attr("data-first-option", "");
      $(".js-forward").attr("data-second-option", "");
      $(".js-back").attr("data-step", "step1");
      $(".js-back").removeClass("show");
      $(".js-forward").addClass("show");

      $(".js-textContainerRight").removeClass("expand");
      $(".ProductMonogram__image-sandal").removeClass("slide-left");
      $(".js-letterContainer").empty();
    });

    /* START JRU-326 2/2(Monogram Shop Broken) */
    function normalizeMonogramColor(value) {
      if (value === "Magenta") return "Fuchsia";
      return value;
    }

    //Loads Size Variants after selecting colors
    function changeImages(tempStitchColor = null) {
      const normalizedColor = normalizeMonogramColor(color);
      const normalizedPattern = normalizeMonogramColor(tempStitchColor || whipstitchColor);

      variants.find((o) => {
        if (
          o.style === style &&
          o.color === normalizedColor &&
          o.pattern === normalizedPattern
        ) {
          var image = o.img;
          console.log("you know i was ", image);
          $(".ProductMonogram__image-sandal .js-mainImage").attr("src", image);
        }
      });
    }

    function addSizeVariant() {
      console.log(style, whipstitchColor, color, stitchColor, $monogramStyle);

      let normalizedColor = normalizeMonogramColor(color);
      let normalizedWhipstitchColor = normalizeMonogramColor(whipstitchColor);

      if (style == "Loafer") {
        normalizedWhipstitchColor = "n/a";
        normalizedColor = "n/a";
      }

      variants.forEach((o) => {
        if (
          o.style === style &&
          o.color === normalizedColor &&
          o.pattern === normalizedWhipstitchColor &&
          o.stitchColor === stitchColor &&
          o.stitchStyle === $monogramStyle
        ) {
          var handle = o.handle;
          console.log(o.color, o.stitchStyle, o.stitchColor, $monogramStyle, handle);
          console.log(`https://www.jackrogersusa.com/products/${handle} /products/${handle}`);
          $.ajax({
            type: "GET",
            // url:'https://www.jackrogersusa.com/products/' + handle,
            url: `/products/${handle}`,
            beforeSend: function () {
              $mobileSize.addClass("loader");
              $(".ProductMonogram__step--5 .ProductMonogram__options").addClass("loader");
              $(".js-sizeMobile").empty();
              $(".js-sizeContainer").empty();
            },
            success: function (data) {
              // var productForm = $(data).find('[data-section-type="product"] .productSelect--custom');
              var productForm = $(data).find(".productSelect--custom.js-variantQuantity");
              var productPrice = $(data).find(".js-price").text();

              $mobileSize.removeClass("loader");
              $mobileSize.append(productForm);

              console.log("product form clone", data, productForm);
              $step5.find(".js-sizeContainer").append(productForm.clone());

              $(".js-stepOne .js-title").click(function () {
                $(".js-letterContainer").empty();
                $(".js-rightExpand .js-variantQuantity").empty();
                $(".js-rightExpand .js-whipstitchLabel").empty();
                $(".js-rightExpand .js-optionColor").empty();
                $(".js-rightExpand .js-optionStitch").empty();
                $(".js-rightExpand .js-addMore--2").empty();
                $(".js-rightExpand .js-add").removeClass("show");
                $(".js-nextOne").attr("disabled", true);
                $(".ProductMonogram__next--0").removeClass("active");
                $(".ProductMonogram__image--block").removeClass("active");
                $(".js-nextTwo").attr("disabled", true).removeClass("active");
                $(".js-nextThree").attr("disabled", true).removeClass("active");
                $(".js-nextFour").attr("disabled", true).removeClass("active");
                $(".js-rightExpand .js-optionStitchColor").empty();

                $(".js-monogramContainer").removeClass("active");
                // $('.ProductMonogram__color--swatches .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item ').each(function(){
                //   $(this).removeClass('show');
                // });

                $(
                  ".ProductMonogram__stitch-color .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });
              });

              $(".js-stepTwo .js-title").click(function () {
                $(".js-letterContainer").empty();
                $(".js-rightExpand .js-variantQuantity").empty();
                $(".js-rightExpand .js-whipstitchLabel").empty();
                $(".js-rightExpand .js-optionColor").empty();
                $(".js-rightExpand .js-optionStitch").empty();
                $(".js-rightExpand .js-addMore--2").empty();
                $(".js-rightExpand .js-add").removeClass("show");
                $(".js-nextTwo").attr("disabled", true);
                $(".ProductMonogram__next--0").removeClass("active");
                $(".ProductMonogram__image--block").removeClass("active");
                $(".js-nextTwo").attr("disabled", true).removeClass("active");
                $(".js-nextThree").attr("disabled", true).removeClass("active");
                $(".js-nextFour").attr("disabled", true).removeClass("active");
                $(".js-rightExpand .js-optionStitchColor").empty();

                $(".js-monogramContainer").removeClass("active");
                $(
                  ".ProductMonogram__color--swatches .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });

                $(
                  ".ProductMonogram__stitch-color .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });
              });

              $(".js-stepThree .js-title").click(function () {
                $(".js-letterContainer").empty();
                $(".js-rightExpand .js-whipstitchLabel").empty();
                $(".js-rightExpand .js-optionStitch").empty();
                $(".js-rightExpand .js-variantQuantity").empty();
                $(".js-rightExpand .js-addMore--2").empty();
                $(".js-rightExpand .js-add").removeClass("show");
                $(".js-nextTwo").attr("disabled", true);
                $(".ProductMonogram__next--0").removeClass("active");
                $(".ProductMonogram__image--block").removeClass("active");
                $(".js-nextTwo").attr("disabled", true).removeClass("active");
                $(".js-nextThree").attr("disabled", true).removeClass("active");
                $(".js-nextFour").attr("disabled", true).removeClass("active");
                $(".js-rightExpand .js-optionStitchColor").empty();

                $(".js-monogramContainer").removeClass("active");
                $(
                  ".ProductMonogram__color--swatches .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });

                $(
                  ".ProductMonogram__stitch-color .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });
              });

              $(".js-stepFour .js-title").click(function () {
                $(".js-rightExpand .js-optionStitch").empty();
                $(".js-rightExpand .js-variantQuantity").empty();
                $(".js-rightExpand .js-addMore--2").empty();
                $(".js-rightExpand .js-add").removeClass("show");
                $(".js-nextTwo").attr("disabled", true);
                $(".ProductMonogram__next--0").removeClass("active");
                $(".ProductMonogram__image--block").removeClass("active");
                $(".js-nextTwo").attr("disabled", true).removeClass("active");
                $(".js-nextThree").attr("disabled", true).removeClass("active");
                $(".js-nextFour").attr("disabled", true).removeClass("active");
                $(".js-monogramContainer").removeClass("active");
                $(".js-rightExpand .js-optionStitchColor").empty();

                $(
                  ".ProductMonogram__color--swatches .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });

                $(
                  ".ProductMonogram__stitch-color .ProductMonogram__swatch--color--container .ProductMonogram__swatch--item "
                ).each(function () {
                  $(this).removeClass("show");
                });
              });

              $("js-stepFive .js-title").click(function () {
                if (style == "Loafer") {
                  whipstitchColor = "n/a";
                  color = "n/a";
                  addSizeVariant();
                }
              });

              $(".price").text(productPrice);
              $(".ProductMonogram__label").addClass("show");
              $(".js-nextFive").addClass("active");
              $(".ProductMonogram__step--5 .ProductMonogram__options").removeClass("loader");
              //script
              $(".SingleOptionSelector-1").change(function () {
                var selectedVal = $(this).val();
              });
              // $('.js-nextFive').attr('disabled', true).removeClass('active');
              $(".js-sizeContainer .js-variant").on("change", function () {
                console.log("changed");
                $(".js-nextFive").attr("disabled", false).addClass("active");
              });

              $(".js-addMore").click(function () {
                console.log("productofrm", productForm.clone());
                $step5.find(".ProductMonogram__size--swatches").append(productForm.clone());
                $(".js-sizeContainer .js-variant").each(function () {
                  // var nullVariant = $(this).val();
                  // if (nullVariant == null){
                  //    $('.js-nextFive').attr('disabled', true).removeClass('active');
                  // }
                });

                $(".js-sizeContainer .js-variant").on("change", function () {
                  console.log("changed");
                  $(".js-nextFive").attr("disabled", false).addClass("active");
                });
              });

              $(".js-addMore--2").click(function () {
                $(".js-sizeContainer2").append(productForm.clone());
                $(".js-sizeContainer2 .js-variant").each(function () {
                  var nullVariant2 = $(this).val();
                  if (nullVariant2 == null) {
                    $(".js-add button").attr("disabled", true).addClass("disabled");
                  }
                });
                $(".js-sizeContainer2 .js-variant").on("change", function () {
                  console.log("changed");
                  $(".js-add button").attr("disabled", false).removeClass("disabled");
                });
              });

              $(".js-sizeMobile .js-variant").each(function () {
                var nullVariant2 = $(this).val();
                if (nullVariant2 == null) {
                  $(".js-addMobile button").attr("disabled", true).addClass("disabled");
                }
              });

              $(".js-sizeMobile .js-variant").on("change", function () {
                console.log("changed");
                $(".js-addMobile button").attr("disabled", false).removeClass("disabled");
              });

              $(".js-addMore--3").click(function () {
                $mobileSize.append(productForm.clone());
                $(".js-sizeMobile .js-variant").each(function () {
                  var nullVariant2 = $(this).val();
                  if (nullVariant2 == null) {
                    $(".js-addMobile button").attr("disabled", true).addClass("disabled");
                  }
                });

                $(".js-sizeMobile .js-variant").on("change", function () {
                  console.log("changed");
                  $(".js-addMobile button").attr("disabled", false).removeClass("disabled");
                });
              });
            },
          });
        }
      });
    }
    /* END JRU-326 2/2(Monogram Shop Broken) */
    initialChecker();
    $(".js-optionCircle").click(function () {
      $(this).closest(".ProductMonogram__option-selector").find("p").removeClass("active");
      $(this).addClass("active");
      console.log("clicked");
      $(".js-diamond").removeClass("show");
      $(this).closest(".js-optionContainer").find(".js-circle").addClass("show");
      $monogramStyle = $(this).data("selection");
      let $total = "";
      $(".js-circle .js-initialForm input").each(function () {
        $total += $(this).val();
      });
      console.log($total.length);
      if ($total.length != 3) {
        $(".js-forward").attr("disabled", true);
      } else {
        $(".js-forward").attr("disabled", false);
      }
    });

    $(".js-optionDiamond").click(function () {
      $(this).closest(".ProductMonogram__option-selector").find("p").removeClass("active");
      $(this).addClass("active");
      $(".js-circle").removeClass("show");
      $(this).closest(".js-optionContainer").find(".js-diamond").addClass("show");
      $monogramStyle = $(this).data("selection");
      console.log($firstLetter, $secondLetter, $thirdLetter);
      let $total = "";
      $(".js-diamond .js-initialForm input").each(function () {
        $total += $(this).val();
      });
      console.log($total.length);
      if ($total.length != 3) {
        $(".js-forward").attr("disabled", true);
      } else {
        $(".js-forward").attr("disabled", false);
      }
    });
  }

  setTimeout(function () {
    monogramJack();
    console.log("monogramJack");

    if (window.location.href.includes("step=1")) {
      $(".js-stepOne .js-title").trigger("click");
      $(".js-mobile").addClass("active");
      $(".js-top").addClass("show");
      $(".ProductMonogram--right").addClass("active");

      window.history.replaceState("", "", "/products/new-monogram-sandal");
    }
  }, 500);

  $(document).on("ready", function () {
    $(document).on("variantImageChange", function (event) {
      // Lets get the old image
      var oldSrc = $("#ProductPhoto img").attr("src");
      // Find out the size of the old image
      var oldSize = concrete.Images.imageSize(oldSrc);
      // Lets get the new image at the correct size
      var newImage = concrete.Images.getImageUrl(event.variant.featured_image.src, oldSize);
      // Change to the new variants image
      $("#ProductPhoto img").attr("src", newImage);
    });

    // But this is a bit long winded so heres an example just using concrete imageSwitch function
    $(document).on("click", "#ProductThumbs img", function (event) {
      concrete.Images.switchImage($("#ProductPhoto img")[0], $(this, event.target)[0]);
    });

    setTimeout(function () {
      productVariant();
    }, 500);
  });
})(jQuery);
